<template>
  <div id="g-page" >
    <table border="0" class="screen" >
      <tr>
        <td id="screen-row1" colspan="1"> 
          <!--MOVES THE VIEW BELOW THE MAIN MENU-->
        </td>
      </tr>
      <!-- TITLE -->
      <tr>
        <td class="screen-table-td">
          <table class="section-table" border="0" align="center">
            <tr>
              <td id="title-left" class="radius-single-left-field-left-top radius-single-left-field-left-bottom radius-single-left-field-right-top radius-single-left-field-right-bottom" >
                  <p>{{ $t("intake.title1") }} <!--Medical History--></p>
              </td>
              <td id="title-right" class="radius-single-right-field-left-top radius-single-right-field-left-bottom radius-single-right-field-right-top radius-single-right-field-right-bottom">
                <!--Please fill out the following form and all of its sections as completely and thoroughly as you can. Note, Items with an asterisk (*) are required. Though most items are not technically required to submit this form, filling it out completely will help us to ensure that you receive the best possible care.-->
                {{ $t("intake.instructions") }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <!-- FORM STATUS -->
      <tr>
        <td class="screen-table-td">
          <div style="height:10px;" />
          <table class="section-table" border="0" align="center">
            <tr>
              <td id="statusMemberInformation" class="status-field radius-top-left-field-top" >
                <!--Member-->
                {{ $t("intake.statusMember") }}
              </td>
              <td id="statusHealthInsurance" class="status-field section-border-left">
                <!--Insurance-->
                {{ $t("intake.statusInsurance") }}
              </td>
              <td id="statusGovernmentInformation" class="status-field section-border-left">
                <!--Government-->
                {{ $t("intake.statusGovernment") }}
              </td>
              <td id="statusMedicalHistory1" class="status-field section-border-left">
                <!--General-->
                {{ $t("intake.statusGeneral") }}
              </td>
              <td id="statusMedicalHistory1Notes" class="status-field section-border-left">
                <!--General Details-->
                {{ $t("intake.statusGeneralDetails") }}
              </td>
              <td id="statusMedicalHistory2" class="status-field section-border-left">
                <!--Conditions-->
                {{ $t("intake.statusConditions") }}
              </td>
              <td id="statusMedicalHistory2Notes" class="status-field section-border-left">
                <!--Condition Details-->
                {{ $t("intake.statusConditionDetails") }}
              </td>
              <td id="statusMedicalHistory3" class="status-field section-border-left">
                <!--Lifestyle-->
                {{ $t("intake.statusLifestyle") }}
              </td>
              <td id="statusMedicalHistory3Notes" class="status-field section-border-left">
                <!--Lifestyle Details-->
                {{ $t("intake.statusLifestyleDetails") }}
              </td>
              <td id="statusSummary" class="status-field section-border-left">
                <!--Review-->
                {{ $t("intake.statusReview") }}
              </td>
              <td id="statusFinished" class="status-field radius-top-right-field-top section-border-left">
                <!--Finished-->
                {{ $t("intake.statusFinished") }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <!-- MEMBER INFORMATION -->
      <tr>
        <td class="screen-table-td">
          <div id="memberInformation" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="mem-section-table-width" border="0" align="center">
                    <tr>
                      <td class="mem-instruction-field" colspan="6">
                        <!--Please complete the following general information:-->
                        {{ $t("intake.memberInstruction") }}
                        <br><br>
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field" ref="first">
                        <!--First:-->
                        {{ $t("intake.memberFirst") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" readonly name="first" v-model="input.first" maxlength="40" style="background-color:lightgray">
                      </td>
                      <td class="mem-text-field">
                        <!--Middle:-->
                        {{ $t("intake.memberMiddle") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" readonly name="middle" v-model="input.middle" maxlength="1" style="background-color:lightgray;">
                      </td>
                      <td class="mem-text-field">
                        <!--Last:-->
                        {{ $t("intake.memberLast") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" readonly name="last" v-model="input.last" maxlength="40" style="background-color:lightgray">
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Street:-->
                        {{ $t("intake.memberStreet") }}
                      </td>
                      <td class="input-field" colspan="3">
                        <input type="text" name="street" v-model="input.street" maxlength="100" style="width:100%" v-bind:placeholder="$t('intake.plYourStreet')">
                      </td>
                      <td class="mem-text-field">
                        <!--Suite:-->
                        {{ $t("intake.memberSuite") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="suite" v-model="input.suite" maxlength="6" v-bind:placeholder="$t('intake.plOptional')">
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*City:-->
                        {{ $t("intake.memberCity") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="city" v-model="input.city" maxlength="50" v-bind:placeholder="$t('intake.plCity')">
                      </td>
                      <td class="mem-text-field">
                        <!--*State:-->
                        {{ $t("intake.memberState") }}
                      </td>
                      <td class="input-field">
                        <select id="stateId" class="member-input-width" name="stateId" v-model="input.stateId" @change="onSelectChange">
                          <option v-for="item in stateList" v-bind:key="item.text" :value="item.id">
                            {{item.text}}
                          </option>
                        </select>
                      </td>
                      <td class="mem-text-field">
                        <!--*Zipcode:-->
                        {{ $t("intake.memberZipcode") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="zipcode" v-mask="'#####'" v-model="input.zipcode" maxlength="10" placeholder="xxxxx">
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Phone:-->
                        {{ $t("intake.memberPhone") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="phone" v-mask="'(###)###-####'" v-model="input.phone" maxlength="13" placeholder="(xxx)xxx-xxxx">
                      </td>
                      <td class="mem-text-field">
                        <!--Extension:-->
                        {{ $t("intake.memberExtension") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="phoneExt" v-model="input.phoneExt" maxlength="6">
                      </td>
                      <td colspan="2"></td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Cell:-->
                        {{ $t("intake.memberCell") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="cell" v-mask="'(###)###-####'" v-model="input.cell" maxlength="13" placeholder="(xxx)xxx-xxxx">
                      </td>
                      <td class="mem-text-field">
                        <!--Fax:-->
                        {{ $t("intake.memberFax") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="member-input-width" name="fax" v-mask="'(###)###-####'" v-model="input.fax" maxlength="13"  placeholder="(xxx)xxx-xxxx">
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Email:-->
                        {{ $t("intake.memberEmail") }}
                      </td>
                      <td class="input-field" colspan="3">
                        <input type="email" name="email" pattern=".+@globex.com" v-model="input.email" style="width:100%" maxlength="125" placeholder="example@domain.com">
                      </td>
                      <td class="input-field-empty" colspan="2" >
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Date of Birth:-->
                        {{ $t("intake.memberDOB") }}
                      </td>
                      <td class="input-field">
                        <input type="date" class="member-input-width" name="dateOfBirth" v-model="dateOfBirth">
                      </td>
                      <td class="mem-text-field">
                        <!--*Gender:-->
                        {{ $t("intake.memberGender") }}
                      </td>
                      <td class="input-field" colspan="3">
                        <input type="radio" name="gender" id="male"  v-model="input.gender" v-bind:value="true">&nbsp;<label for="male"><!--Male-->{{ $t("intake.memberMale") }}</label>&nbsp;
                        <input type="radio" name="gender" id="female" v-model="input.gender" v-bind:value="false">&nbsp;<label for="female"><!--Female-->{{ $t("intake.memberFemale") }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td class="mem-text-field">
                        <!--*Language:-->
                        {{ $t("intake.memberLanguage") }}
                      </td>
                      <td id="languageId" class="input-field">
                        <select class="member-input-width" name="languageId" v-model="input.languageId">
                          <option value="0"><!--Select-one-->{{ $t("intake.selectOne") }}</option>
                          <option value="1">English (United States)</option>
                          <option value="2">Spanish</option>
                        </select>
                      </td>
                      <td class="mem-text-field">
                        <!--*Handedness:-->
                        {{ $t("intake.memberHandedness") }}
                      </td>
                      <td id="handednessId" class="input-field">
                        <select class="member-input-width" name="languageId" v-model="input.handednessId">
                          <option value="0"><!--Select-one-->{{ $t("intake.selectOne") }}</option>
                          <option value="1"><!--Right-->{{ $t("intake.right") }}</option>
                          <option value="2"><!--Left-->{{ $t("intake.left") }}</option>
                        </select>
                      </td>
                      <td colspan="2">
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- HEALTH INSURANCE -->
      <tr>
        <td class="screen-table-td">
          <div id="healthInsurance" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="ins-section-table-width" border="0" align="center">
                    <tr>
                      <td class="ins-instruction-field" colspan="2">
                        <!--Please enter your current health insurance information:-->
                        {{ $t("intake.insInstruction") }}
                        <br><br>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Insurer:-->
                        {{ $t("intake.insInsurer") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="ins-input-width" name="insurancePayer" v-model="input.insurancePayer" maxlength="60" v-bind:placeholder="$t('intake.plInsurersName')">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Insurer:-->
                        {{ $t("intake.insPlanName") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="ins-input-width" name="planName" v-model="input.planName" maxlength="40" v-bind:placeholder="$t('intake.plPlanName')">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Insurer:-->
                        {{ $t("intake.insPlanType") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="ins-input-width" name="planType" v-model="input.planType" maxlength="40" v-bind:placeholder="$t('intake.plPlanType')">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Effective Date:-->
                        {{ $t("intake.insDate") }}
                      </td>
                      <td class="input-field">
                        <input type="date" class="ins-input-width" name="coverageEffectiveDate" v-model="coverageEffectiveDate">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Group Number:-->
                        {{ $t("intake.insGroup") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="ins-input-width" name="planGroupNumber" v-model="input.planGroupNumber" maxlength="20" v-bind:placeholder="$t('intake.plGroupNumber')">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--*Member Number:-->
                        {{ $t("intake.insMember") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="ins-input-width" name="insuranceIdentifier" v-model="input.insuranceIdentifier" maxlength="25" v-bind:placeholder="$t('intake.plMemberNumber')">
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- GOV INFORMATION -->
      <tr>
        <td class="screen-table-td">
          <div id="govInformation" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="gov-section-table-width" border="0" align="center">
                    <tr>
                      <td class="gov-instruction-field" colspan="2">
                        <!--For company Drug testing program and/or DOT physicals-->
                        {{ $t("intake.govInstruction1") }}
                        <br><br>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field input-field-half">
                        <!--Drivers License Number:-->
                        {{ $t("intake.govLicNumber") }}
                      </td>
                      <td class="input-field">
                        <input type="text" class="gov-input-width" name="driversLicense" v-model="input.driversLicense" maxlength="16" v-bind:placeholder="$t('intake.plDriversLicense')">
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--Issuing State:-->
                        {{ $t("intake.govLicState") }}
                      </td>
                      <td class="input-field">
                        <select id="driversLicenseStateId" class="gov-input-width" name="driversLicenseStateId" v-model="input.driversLicenseStateId">
                          <option v-for="item in stateList" v-bind:key="item.text" :value="item.id">
                            {{item.text}}
                          </option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--License Class:-->
                        {{ $t("intake.govLicClass") }}
                      </td>
                      <td class="input-field">
                        <select id="driversLicenseClassId" class="gov-input-width" name="driversLicenseClassId" v-model="input.driversLicenseClassId">
                          <option value="0"><!--Select-one-->{{ $t("intake.selectOne") }}</option>
                          <option value="1"><!--Class A - 18 Wheelers-->{{ $t("intake.govClassA") }}</option>
                          <option value="2"><!--Class B - Straight Trucks/Busses-->{{ $t("intake.govClassB") }}</option>
                          <option value="3"><!--Class C - Double/Trip/Hazard-->{{ $t("intake.govClassC") }}</option>
                          <option value="3"><!--Class D - Single under 26,001 lbs-->{{ $t("intake.govClassD") }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--CLP/CDL Applicant/Holder:-->
                        {{ $t("intake.govCLPCDL") }}
                      </td>
                      <td class="input-field">
                        <input type="radio" name="CLP" v-model="input.cplCdlApplicationHolder" v-bind:value="true"><label><!--Yes-->{{ $t("intake.yes") }}</label>&nbsp;
                        <input type="radio" name="CLP" v-model="input.cplCdlApplicationHolder" v-bind:value="false"><label><!--No-->{{ $t("intake.no") }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <!--Has your USDOT/FMCSA medical certificate ever been denied or issued for less than 2 years?:-->
                        {{ $t("intake.govUSDOT1") }}
                        <br>
                        <br>
                      </td>
                      <td class="input-field">
                        <input type="radio" name="USDOT" v-model="input.usdotFmcsaCertDenied" v-bind:value="true"><label><!--Yes-->{{ $t("intake.yes") }}</label>&nbsp;
                        <input type="radio" name="USDOT" v-model="input.usdotFmcsaCertDenied" v-bind:value="false"><label>{{ $t("intake.no") }}</label>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- MEDICAL HISTORY 1 - GENERAL -->
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory1" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="gen-section-table-width" border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <!--Please tell us about any hospitalizations and/or any medications you are currently taking.-->
                        {{ $t("intake.genInstruction1") }}
                        <br><br>
                        <div style="hieght:40px"/>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field text-field-half">
                        <!--Who is providing this medical history?-->
                        {{ $t("intake.genSource") }}
                      </td>
                      <td class="input-field">
                        <select name="sourceOfHistoryId" v-model="input.sourceOfHistoryId" @change="onSelectChange">
                          <option v-for="item in historySource" v-bind:key="item.text" :value="item.id">
                            {{item.text}}
                          </option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <label id="lblHadSurgery">
                          <!--Have you ever had surgery?-->
                          {{ $t("intake.genHadSurgery") }}
                        </label>
                      </td>
                      <td class="input-field">
                        <input type="checkbox" name="hadSurgery" v-model="input.hadSurgery" >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field" >
                        <label id="lblTakingMedications">
                          <!--Are you currently taking any medications?-->
                          {{ $t("intake.genTakingMeds") }}
                        </label>
                      </td>
                      <td class="input-field">
                        <input type="checkbox" name="takingMedications" v-model="input.takingMedications" >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <label id="lblWereYouHospitalized">
                          <!--Have you ever been Hospitalized?-->
                          {{ $t("intake.genBeenHospitalized") }}
                        </label>
                      </td>
                      <td class="input-field">
                        <input type="checkbox" name="wereYouHospitalized" v-model="input.wereYouHospitalized" >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-field">
                        <label id="lblNightInHospital">
                          <!--Have you ever spent a night in the hospital?-->
                          {{ $t("intake.genNightInHospital") }}
                        </label>
                      </td>
                      <td class="input-field">
                        <input type="checkbox" name="nightInHospital" v-model="input.nightInHospital">
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- MEDICAL HISTORY 1 NOTES - GENERAL DETAILS-->
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory1Notes" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <!--Please provide a complete set of details for each of the general item(s) you selected.-->
                        {{ $t("intake.genDetInstruction1") }}
                        <br>
                        <br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <!-- PROVIDING MEDICAL HISTORY -->
                        <div id="hadSurgeryExplanation" class="border-dots condition-div" v-if="input.hadSurgery">
                          <span class="text-field"><!--Have you ever had surgery?:-->{{ $t("intake.genHadSurgery") }}</span><br>
                          <textarea name="hadSurgeryCondition" class="condition" v-model="input.hadSurgeryExplanation" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('hadSurgery')">
                        </div>
                        <!-- TAKING MEDICATIONS -->
                        <div id="takingMedicationsExplanation" class="border-dots condition-div" v-if="input.takingMedications">
                          <span class="text-field"><!--Are you currently taking any medications?:-->{{ $t("intake.genTakingMeds") }}</span><br>
                          <textarea name="takingMedicationsCondition" class="condition" v-model="input.takingMedicationsExplanation" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('takingMedications')">
                          <br><br>
                          <a style="color:white;text-decoration: underline;" href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/2020-04/MCSA-5895%20Form%204-10-2020%20508.pdf" target="_blank">
                          <!--391.41 CMV DRIVER MEDICATION FORM:-->
                          {{ $t("intake.condDetInsulinForm2") }}
                          </a>
                        </div>
                        <!-- EVER BEEN HOSPITALIZED -->
                        <div id="wereYouHospitalizedNotes" class="border-dots condition-div" v-if="input.wereYouHospitalized">
                          <span class="text-field"><!--Have you ever been Hospitalized?:-->{{ $t("intake.genBeenHospitalized") }}</span><br>
                          <textarea name="wereYouHospitalizedCondition" class="condition" v-model="input.wereYouHospitalizedNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('wereYouHospitalized')">
                        </div>
                        <!-- SPENT NIGHT IN HOSPITAL -->
                        <div id="nightInHospitalNotes" class="border-dots condition-div" v-if="input.nightInHospital">
                          <span class="text-field"><!--Have you ever spent a night in the hopsital?:-->{{ $t("intake.genNightInHospital") }}</span><br>
                          <textarea name="nightInHospitalCondition" class="condition" v-model="input.nightInHostpitalNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('nightInHospital')">
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>    
      </tr>
      <!-- MEDICAL HISTORY 2 - CONDITIONS -->
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory2" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="cond-section-table-width" border="0" align="center">
                    <tr>
                      <td class="cond-instruction-field" colspan="4">
                        <!--Have you been diagnosed with or experienced issues with any of the following conditions? Please check all that apply:-->
                        {{ $t("intake.condInstruction1") }}
                        <br><br>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="headBrain" v-model="input.headBrain" >
                        &nbsp;
                        <label id="lblHeadBrain">
                          <!--Head/brain injuries or illnesses (e.g., concussion)-->
                          {{ $t("intake.condHeadBrain") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="heartDisease" v-model="input.heartDisease">
                        &nbsp;
                        <label id="lblHeartDisease">
                          <!--Heart disease, heart attack, bypass, or other heart problems-->
                          {{ $t("intake.condHeartDisease") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="chronicCough" v-model="input.chronicCough">
                        &nbsp;
                        <label id="lblChronicCough">
                          <!--Chronic (long-term) cough, shortness of breath, or other breathing problems-->
                          {{ $t("intake.condChronicCough") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="dizzinessHeadaches" v-model="input.dizzinessHeadaches">
                        &nbsp;
                        <label id="lblDizzinessHeadaches">
                          <!--Dizziness, headaches, numbness, tingling, or memory loss-->
                          {{ $t("intake.condDizzinessHeadaches") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="anxietyDepression" v-model="input.anxietyDepression">
                        &nbsp;
                        <label id="lblAnxietyDepression">
                          <!--Anxiety, depression, nervousness, other mental health problems-->
                          {{ $t("intake.condAnxietyDepression") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="paceMakerStents" v-model="input.paceMakerStents">
                        &nbsp;
                        <label id="lblPaceMakerStents">
                          <!--Pacemaker,stents, implantable devices, or other heart procedures-->
                          {{ $t("intake.condPaceMakerStents") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="kidneyProblems" v-model="input.kidneyProblems">
                        &nbsp;
                        <label id="lblKidneyProblems">
                          <!--Kidney problems, kidney stones, or pain/problems with urination-->
                          {{ $t("intake.condKidneyProblems") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="sleepingDisorders" v-model="input.sleepingDisorders">
                        &nbsp;
                        <label id="lblSleepingDisorders">
                          <!--Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring-->
                          {{ $t("intake.condSleepingDisorders") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="seizuresEpilepsy" v-model="input.seizuresEpilepsy">
                        &nbsp;
                        <label id="lblSeizuresEpilepsy">
                          <!--Seizures, epilepsy-->
                          {{ $t("intake.condSeizuresEpilepsy") }}
                        </label>
                      </td>
                      
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="highBloodPressure" v-model="input.highBloodPressure">
                        &nbsp;
                        <label id="lblHighBloodPressure">
                          <!--High Blood Pressure-->
                          {{ $t("intake.condHighBloodPressure") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="lungDisease" v-model="input.lungDisease">
                        &nbsp;
                        <label id="lblLungDisease">
                          <!--Lung disease (e.g., asthma)-->
                          {{ $t("intake.condLungDisease") }}
                        </label>
                      </td> 
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="neckBack" v-model="input.neckBack">
                        &nbsp;
                        <label id="lblNeckBack">
                          <!--Neck or back problems-->
                          {{ $t("intake.condNeckBack") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="earHearingProblems" v-model="input.earHearingProblems">
                        &nbsp;
                        <label id="lblEarHearingProblems">
                          <!--Ear and/or hearing problems-->
                          {{ $t("intake.condEarHearingProblems") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="unexplainedWeightLoss" v-model="input.unexplainedWeightLoss">
                        &nbsp;
                        <label id="lblUnexplainedWeightLoss">
                          <!--Unexplained Weight Loss-->
                          {{ $t("intake.condUnexplainedWeightLoss") }}
                        </label>
                      </td>                    
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="stomachLiver" v-model="input.stomachLiver">
                        &nbsp;
                        <label id="lblStomachLiver">
                          <!--Stomach, liver, or digestive problems-->
                          {{ $t("intake.condStomachLiver") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="bloodClotsBleeding" v-model="input.bloodClotsBleeding">
                        &nbsp;
                        <label id="lblBloodClotsBleeding">
                          <!--Blood clots or bleeding problems-->
                          {{ $t("intake.condBloodClotsBleeding") }}
                        </label>
                      </td>                     
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="diabetes" @change="onDiabetes($event)" v-model="input.diabetes">
                        &nbsp;
                        <label id="lblDiabetes">
                          <!--Diabetes or blood sugar problems-->
                          {{ $t("intake.condDiabetes") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="insulinUsed" @change="onInsulinUsed($event)" v-model="input.insulinUsed">
                        &nbsp;
                        <label id="lblInsulinUsed">
                          <!--Insulin used-->
                          {{ $t("intake.condInsulinUsed") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="boneMuscle" v-model="input.boneMuscle">
                        &nbsp;
                        <label id="lblBoneMuscle">
                          <!--Bone, muscle, joint, or nerve problems-->
                          {{ $t("intake.condBoneMuscle") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="chronicInfection" v-model="input.chronicInfection">
                        &nbsp;
                        <label id="lblChronicInfection">
                          <!--Chronic (long-term) infection or other chronic diseases-->
                          {{ $t("intake.condChronicInfection") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="eyeProblems" v-model="input.eyeProblems">
                        &nbsp;
                        <label id="lblEyeProblems">
                          <!--Eye problems (except glasses or contacts)-->
                          {{ $t("intake.condEyeProblems") }}
                        </label>
                      </td>                   
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="stroke" v-model="input.stroke">
                        &nbsp;
                        <label id="lblStroke">
                          <!--Stroke, mini-stroke (TIA), paralysis, or weakness-->
                          {{ $t("intake.condStroke") }}
                        </label>
                      </td>                     
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="missingLimitedUserOfArms" v-model="input.missingLimitedUserOfArms">
                        &nbsp;
                        <label id="lblMissingLimitedUserOfArms">
                          <!--Missing or limited use of arm, hand, finger, leg, foot, toe-->
                          {{ $t("intake.condMissingLimitedUserOfArms") }}
                        </label>
                      </td>
                      <td colspan="1" class="input-field table-td-pad">
                        <input type="checkbox" name="brokenBone" v-model="input.brokenBone">
                        &nbsp;
                        <label id="lblBrokenBone">
                          <!--Have you ever had a broken bone?-->
                          {{ $t("intake.condBrokenBone") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="fainting" v-model="input.fainting">
                        &nbsp;
                        <label id="lblFainting">
                          <!--Fainting or passing out-->
                          {{ $t("intake.condFainting") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="highCholesterol" v-model="input.highCholesterol" >
                        &nbsp;
                        <label id="lblHighCholesterol">
                          <!--High Cholesterol-->
                          {{ $t("intake.condHighCholesterol") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="cancer" v-model="input.cancer">
                        &nbsp;
                        <label id="lblCancer">
                          <!--Cancer-->
                          {{ $t("intake.condCancer") }}
                        </label>
                      </td>
                      <td></td>
                    </tr>
                    
                    
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- MEDICAL HISTORY 2 NOTES - CONDITION DETAILS-->    
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory2Notes" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <!--Please provide a complete set of details for each of the medical conditions you selected.-->
                        {{ $t("intake.condDetInstruction1") }}
                        <br><br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <!-- HEAD BRAIN -->
                        <div id="headBrainNotes" class="border-dots condition-div" v-if="input.headBrain">
                          <span class="text-field"><!--Head/brain injuries or illnesses (e.g., concussion)-->{{ $t("intake.condHeadBrain") }}</span><br>
                          <textarea name="headBrainCondition" class="condition" v-model="input.headBrainNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('headBrain')">
                        </div>
                        <!-- SEIZURES OR EPILEPSY -->
                        <div id="seizuresEpilepsyNotes" class="border-dots condition-div" v-if="input.seizuresEpilepsy" >
                          <span class="text-field"><!--Seizures or Epilepsy-->{{ $t("intake.condSeizuresEpilepsy") }}</span><br>
                          <textarea name="seizuresEpilepsyCondition" class="condition" v-model="input.seizuresEpilepsyNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('seizuresEpilepsy')">
                        </div>
                        <!-- EYE PROBLEMS -->
                        <div id="eyeProblemsNotes" class="border-dots condition-div" v-if="input.eyeProblems" >
                          <span class="text-field"><!--Eye problems (except glasses or contacts)-->{{ $t("intake.condEyeProblems") }}</span><br>
                          <textarea name="eyeProblemsCondition" class="condition" v-model="input.eyeProblemsNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('eyeProblems')">
                        </div>
                        <!-- EAR / HEARING  PROBLEMS -->
                        <div id="earHearingProblemsNotes" class="border-dots condition-div" v-if="input.earHearingProblems" >
                          <span class="text-field"><!--Ear and/or hearing problems-->{{ $t("intake.condEarHearingProblems") }}</span><br>
                          <textarea name="earHearingProblemsCondition" class="condition" v-model="input.earHearingProblemsNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('earHearingProblems')">
                        </div>
                        <!-- DIABETES -->
                        <div id="diabetesNotes" class="border-dots condition-div" v-if="input.diabetes" >
                          <span class="text-field"><!--Diabetes-->{{ $t("intake.condDiabetes") }}</span><br>
                          <textarea name="diabetesCondition" class="condition" v-model="input.diabetesNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('diabetes')">
                        </div>
                        <!-- INSULIN USED -->
                        <div id="insulinUsedNotes" class="border-dots condition-div" v-if="input.insulinUsed" >
                          <span class="text-field"><!--Insulin Used-->{{ $t("intake.condInsulinUsed") }}</span><br>
                          <textarea name="insulinUsedCondition" class="condition" v-model="input.insulinUsedNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('insulinUsed')">
                          <br>
                          <br>
                          <!--i.	IF YOU ARE FILLING OUT THIS INFORMATION FOR YOUR UPCOMMING DOT PHYSICAL PLEASE DOWNLOAD AND HAVE YOUR DOCTOR FILL OUT THE FOLLOWING FORM REGARDING YOUR INSULIN USE-->
                          <span style="color:white;">{{ $t("intake.condDetInsulinForm2Text") }}</span>
                          <br>
                          <br>
                          <a style="color:white;text-decoration: underline;" href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/docs/regulations/medical/422521/itdm-assessment-form-final.pdf" target="_blank">
                          <!--INSULIN-TREATED DIABETES MELLITUS ASSESSMENT FORM:-->
                          {{ $t("intake.condDetInsulinForm1") }}
                          </a>
                          <br>
                        </div>
                        <!-- ANXIETY / DEPRESION -->
                        <div id="anxietyDepressionNotes" class="border-dots condition-div" v-if="input.anxietyDepression" >
                          <span class="text-field"><!--Anxiety, depression, nervousness, other mental health problems-->{{ $t("intake.condAnxietyDepression") }}</span><br>
                          <textarea name="anxietyDepressionCondition" class="condition" v-model="input.anxietyDepressionNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('anxietyDepression')">
                        </div>
                        <!-- FAINTING -->
                        <div id="faintingNotes" class="border-dots condition-div" v-if="input.fainting" >
                          <span class="text-field"><!--Fainting or passing out-->{{ $t("intake.condFainting") }}</span><br>
                          <textarea name="faintingCondition" class="condition" v-model="input.faintingNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('fainting')">
                        </div>
                        <!-- HEART DISEASE -->
                        <div id="heartDiseaseNotes" class="border-dots condition-div" v-if="input.heartDisease" >
                          <span class="text-field"><!--Heart disease, heart attack, bypass, or other heart problems-->{{ $t("intake.condHeartDisease") }}</span><br>
                          <textarea name="heartDiseaseCondition" class="condition" v-model="input.heartDiseaseNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('heartDisease')">
                        </div>
                        <!-- PACEMAKER / STENTS -->
                        <div id="paceMakerStentsNotes" class="border-dots condition-div" v-if="input.paceMakerStents" >
                          <span class="text-field"><!--Pacemaker,stents, implantable devices, or other heart procedures-->{{ $t("intake.condPaceMakerStents") }}</span><br>
                          <textarea name="paceMakerStentsCondition" class="condition" v-model="input.paceMakerStentsNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('paceMakerStents')">
                        </div>
                        <!-- HIGH BLOOD PRESSURE -->
                        <div id="highBloodPressureNotes" class="border-dots condition-div" v-if="input.highBloodPressure" >
                          <span class="text-field"><!--High Blood Pressure-->{{ $t("intake.condHighBloodPressure") }}</span><br>
                          <textarea name="highBloodPressureCondition" class="condition" v-model="input.highBloodPressureNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('highBloodPressure')">
                        </div>
                        <!-- HIGH CHOLESTEROL -->
                        <div id="highCholesterolNotes" class="border-dots condition-div" v-if="input.highCholesterol" >
                          <span class="text-field"><!--High Cholesterol-->{{ $t("intake.condHighCholesterol") }}</span><br>
                          <textarea name="highCholesterolCondition" class="condition" v-model="input.highCholesterolNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('highCholesterol')">
                        </div>
                        <!-- UNEXPLAINED WEIGHT LOSS -->
                        <div id="unexplainedWeightLossNotes" class="border-dots condition-div" v-if="input.unexplainedWeightLoss" >
                          <span class="text-field"><!--Unexplained Weight Loss-->{{ $t("intake.condUnexplainedWeightLoss") }}</span><br>
                          <textarea name="unexplainedWeightLossCondition" class="condition" v-model="input.unexplainedWeightLossNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('unexplainedWeightLoss')">
                        </div>
                        <!-- STROKE -->
                        <div id="strokeNotes" class="border-dots condition-div" v-if="input.stroke" >
                          <span class="text-field"><!--Stroke, mini-stroke (TIA), paralysis, or weakness-->{{ $t("intake.condStroke") }}</span><br>
                          <textarea name="strokeCondition" class="condition" v-model="input.strokeNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('stroke')">
                        </div>
                        <!-- EVER BROKEN A BONE -->
                        <div id="brokenBoneNotes" class="border-dots condition-div" v-if="input.brokenBone" >
                          <span class="text-field"><!--Have you ever had a broken bone?-->{{ $t("intake.condBrokenBone") }}</span><br>
                          <textarea name="brokenBoneCondition" class="condition" v-model="input.brokenBoneNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('brokenBone')">
                        </div>
                        <!-- CHRONIC COUGH -->
                        <div id="chronicCoughNotes" class="border-dots condition-div" v-if="input.chronicCough" >
                          <span class="text-field"><!--Chronic (long-term) cough, shortness of breath, or other breathing problems-->{{ $t("intake.condChronicCough") }}</span><br>
                          <textarea name="chronicCoughCondition" class="condition" v-model="input.chronicCoughNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('chronicCough')">
                        </div>
                        <!-- LUNG DISEASE -->
                        <div id="lungDiseaseNotes" class="border-dots condition-div" v-if="input.lungDisease" >
                          <span class="text-field"><!--Lung disease (e.g., asthma)-->{{ $t("intake.condLungDisease") }}</span><br>
                          <textarea name="lungDiseaseCondition" class="condition" v-model="input.lungDiseaseNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('lungDisease')">
                        </div>
                        <!-- KIDNEY PROBLEMS -->
                        <div id="kidneyProblemsNotes" class="border-dots condition-div" v-if="input.kidneyProblems" >
                          <span class="text-field"><!--Kidney problems, kidney stones, or pain/problems with urination-->{{ $t("intake.condKidneyProblems") }}</span><br>
                          <textarea name="kidneyProblemsCondition" class="condition" v-model="input.kidneyProblemsNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('kidneyProblems')">
                        </div>
                        <!-- STOMACH / LIVER -->
                        <div id="stomachLiverNotes" class="border-dots condition-div" v-if="input.stomachLiver" >
                          <span class="text-field"><!--Stomach, liver, or digestive problems-->{{ $t("intake.condStomachLiver") }}</span><br>
                          <textarea name="stomachLiverCondition" class="condition" v-model="input.stomachLiverNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('stomachLiver')">
                        </div>
                        <!-- BONE / MUSCLE -->
                        <div id="boneMusclerNotes" class="border-dots condition-div" v-if="input.boneMuscle" >
                          <span class="text-field"><!--Bone, muscle, joint, or nerve problems-->{{ $t("intake.condBoneMuscle") }}</span><br>
                          <textarea name="boneMuscleCondition" class="condition" v-model="input.boneMuscleNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('boneMuscle')">
                        </div>
                        <!-- CANCER -->
                        <div id="cancerNotes" class="border-dots condition-div" v-if="input.cancer" >
                          <span class="text-field"><!--Cancer-->{{ $t("intake.condCancer") }}</span><br>
                          <textarea name="cancerCondition" class="condition" v-model="input.cancerNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('cancer')">
                        </div>
                        <!-- DIZZINESS / HEADACHES -->
                        <div id="dizzinessHeadachesNotes" class="border-dots condition-div" v-if="input.dizzinessHeadaches" >
                          <span class="text-field"><!--Dizziness, headaches, numbness, tingling, or memory loss-->{{ $t("intake.condDizzinessHeadaches") }}</span><br>
                          <textarea name="dizzinessHeadachesCondition" class="condition" v-model="input.dizzinessHeadachesNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('dizzinessHeadaches')">
                        </div>
                        <!-- BLOOD CLOTS OR BLEEDING -->
                        <div id="bloodClotsBleedingNotes" class="border-dots condition-div" v-if="input.bloodClotsBleeding" >
                          <span class="text-field"><!--Blood Clots or Bleeding-->{{ $t("intake.condBloodClotsBleeding") }}</span><br>
                          <textarea name="bloodClotsBleedingCondition" class="condition" v-model="input.bloodClotsBleedingNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('bloodClotsBleeding')">
                        </div>
                        <!-- NECK / BACK -->
                        <div id="neckBackNotes" class="border-dots condition-div" v-if="input.neckBack" >
                          <span class="text-field"><!--Neck or back problems-->{{ $t("intake.condNeckBack") }}</span><br>
                          <textarea name="neckBackCondition" class="condition" v-model="input.neckBackNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('neckBack')">
                        </div>
                        <!-- SLEEP DISORDERS -->
                        <div id="sleepingDisordersNotes" class="border-dots condition-div" v-if="input.sleepingDisorders" >
                          <span class="text-field"><!--Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring-->{{ $t("intake.condSleepingDisorders") }}</span><br>
                          <textarea name="sleepingDisordersCondition" class="condition" v-model="input.sleepingDisordersNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('sleepingDisorders')">
                        </div>
                        <!-- CHRONIC / INFECTION -->
                        <div id="chronicInfectionDisordersNotes" class="border-dots condition-div" v-if="input.chronicInfection" >
                          <span class="text-field"><!--Chronic (long-term) infection or other chronic diseases-->{{ $t("intake.condChronicInfection") }}</span><br>
                          <textarea name="chronicInfectionCondition" class="condition" v-model="input.chronicInfectionNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('chronicInfection')">
                        </div>
                        <!-- MISSING LIMITED USE OF ANY LIMBS -->
                        <div id="missingLimitedUserOfArmsNotes" class="border-dots condition-div" v-if="input.missingLimitedUserOfArms" >
                          <span class="text-field"><!--Missing or limited use of arm, hand, finger, leg, foot, toe-->{{ $t("intake.condMissingLimitedUserOfArms") }}</span><br>
                          <textarea name="missingLimitedUserOfArmsCondition" class="condition" v-model="input.missingLimitedUserOfArmsNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('missingLimitedUserOfArms')">
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- MEDICAL HISTORY 3 - LIFESTYLE -->
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory3" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="3">
                        <!--Have you ever used or experienced any of the following? Please check all that apply:-->
                        {{ $t("intake.lifeInstruction1") }}
                        <br>
                        <br>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="treatedForSubstance" v-model="input.treatedForSubstance">
                        &nbsp;
                        <label id="lblTreatedForSubstance">
                          <!--Have you Ever been Treated For Substance Issue-->
                          {{ $t("intake.lifeTreatedForSubstance") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad input-field-third">
                        <input type="checkbox" name="useTobacco" v-model="input.useTobacco">
                        &nbsp;
                        <label id="lblUseTobacco">
                          <!--Have you ever used or do you now use tobacco?-->
                          {{ $t("intake.lifeUseTobacco") }}
                        </label>
                      </td>
                      <td class="input-field table-td-pad input-field-third">
                        <input type="checkbox" name="illegalSubstance" v-model="input.illegalSubstance">
                        &nbsp;
                        <label id="lblllegalSubstance">
                          <!--Have you used an illegal substance within the past two years?-->
                          {{ $t("intake.lifeIllegalSubstance") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad input-field-third">
                        <input type="checkbox" name="drinkAlcohol" v-model="input.drinkAlcohol">
                        &nbsp;
                        <label id="lblDrinkAlcohol">
                          <!--Do you currently drink alcohol?-->
                          {{ $t("intake.lifeDrinkAlcohol") }}
                        </label>
                      </td>
                      <td colspan="1" class="input-field table-td-pad">
                        <input type="checkbox" name="sleepTest" v-model="input.sleepTest">
                        &nbsp;
                        <label id="lblSleepTest">
                          <!--Have you ever had a sleep test-->
                          {{ $t("intake.lifeSleepTest") }}
                        </label>
                      </td>                    
                      <td class="input-field table-td-pad" colspan="3">
                        <input type="checkbox" name="otherHealthCondition" v-model="input.otherHealthCondition">
                        &nbsp;
                        <label id="lblOtherHealthCondition">
                          <!--Other Health Condition-->
                          {{ $t("intake.lifeOtherHealthCondition") }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td class="input-field table-td-pad">
                        <input type="checkbox" name="everFailedDrugTest" v-model="input.everFailedDrugTest">
                        &nbsp;
                        <label id="lblEverFailedDrugTest">
                          <!--Have you ever failed a drug test or been dependent on an illegal substance?-->
                          {{ $t("intake.lifeEverFailedDrugTest") }}
                        </label>
                      </td>
                      
                      <td colspan="2"></td>
                      
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- MEDICAL HISTORY 3 NOTES - LIFESTYLE DETAILS -->
      <tr>
        <td class="screen-table-td">
          <div id="medicalHistory3Notes" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <!--Please provide a complete set of details for each of the medical conditions you selected.-->
                        {{ $t("intake.lifeDetInstruction1") }}
                        <br>
                        <br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <!-- DRINK ALCOHOL -->
                        <div id="drinkAlcoholNotes" class="border-dots condition-div" v-if="input.drinkAlcohol">
                          <span class="text-field"><!--Do you currently drink alcohol?-->{{ $t("intake.lifeDrinkAlcohol") }}</span><br>
                          <textarea name="drinkAlcoholCondition" class="condition" v-model="input.drinkAlcoholNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('drinkAlcohol')">
                        </div>
                        <!-- TREATED FOR SUBSTANCE -->
                        <div id="treatedForSubstanceNotes" class="border-dots condition-div" v-if="input.treatedForSubstance">
                          <span class="text-field"><!--Have you Ever been Treated For Substance Issue?-->{{ $t("intake.lifeTreatedForSubstance") }}</span><br>
                          <textarea name="treatedForSubstanceCondition" class="condition" v-model="input.treatedForSubstanceNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('treatedForSubstance')">
                        </div>
                        <!-- OTHER HEALTH CONDITION -->
                        <div id="otherHealthConditionNotes" class="border-dots condition-div" v-if="input.otherHealthCondition">
                          <span class="text-field"><!--Other Health Condition-->{{ $t("intake.lifeOtherHealthCondition") }}</span><br>
                          <textarea name="otherHealthConditionCondition" class="condition" v-model="input.otherHealthConditionNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('otherHealthCondition')">
                        </div>
                        <!-- USE TOBACCO -->
                        <div id="useTobaccoNotes" class="border-dots condition-div" v-if="input.useTobacco">
                          <span class="text-field"><!--Have you ever used or do you now use tobacco?-->{{ $t("intake.lifeUseTobacco") }}</span><br>
                          <textarea name="useTobaccoCondition" class="condition" v-model="input.useTobaccoNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('useTobacco')">
                        </div>
                        <!-- FAILED DRUG TEST -->
                        <div id="everFailedDrugTestNotes" class="border-dots condition-div" v-if="input.everFailedDrugTest">
                          <span class="text-field"><!--Have you ever failed a drug test or been dependent on an illegal substance?-->{{ $t("intake.lifeEverFailedDrugTest") }}</span><br>
                          <textarea name="everFailedDrugTestCondition" class="condition" v-model="input.everFailedDrugTestNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('everFailedDrugTest')">
                        </div>
                        <!-- ILLEGAL SUBSTANCES -->
                        <div id="illegalSubstanceNotes" class="border-dots condition-div" v-if="input.illegalSubstance">
                          <span class="text-field"><!--Have you used an illegal substance within the past two years?-->{{ $t("intake.lifeIllegalSubstance") }}</span><br>
                          <textarea name="illegalSubstanceCondition" class="condition" v-model="input.illegalSubstanceNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('illegalSubstance')">
                        </div>
                        <!-- SLEEP TEST -->
                        <div id="sleepTestNotes" class="border-dots condition-div" v-if="input.sleepTest">
                          <span class="text-field"><!--Have you ever had a sleep test (e.g., sleep apnea)?-->{{ $t("intake.lifeSleepTest") }}</span><br>
                          <textarea name="sleepTestCondition" class="condition" v-model="input.sleepTestNote" maxlength="1000" v-bind:placeholder="$t('intake.plDescription')"></textarea>
                          <input type="button" :value="$t('intake.remove')" v-on:click="clearNote('sleepTest')">
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      
      </tr>
      <!-- SUMMARY - REVIEW -->
      <tr>
        <td class="screen-table-td">
          <div id="summary" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center" style="background-color:white !important;">
                    <tr>
                      <td class="sum-instruction-field">
                        <!--Please review all of the information below and then click "Submit Medical History" at the bottom of the page to continue.-->
                        {{ $t("intake.revInstruction1") }}
                        <br>
                        <br>
                        
                      </td>
                    </tr>
                    <tr>
                      <td class="printtd">
                        <input type="button" v-on:click="print()" value="Print">
                        </td>
                      </tr>
                    <tr id="printSection" >
                      <td>
                        <!-- <div>
                          <p style="color:white;text-align:left" v-html="writeSummary()"></p>
                        </div> -->
                        <table border="1" align="center" style="margin:3px;">
                          
                          <tr>
                            <td class="review-section" colspan="4">
                              <!--*** MEMBER ***-->
                              {{ $t("intake.revMemberTitle") }}
                            </td>
                          </tr>
                          
                          <tr>
                            <td class="review-field-title review-field-quarter" colspan="1"><!--Name:-->{{ $t("intake.revMemberName") }}</td>
                            <td class="review-field review-field-full" colspan="3">{{ this.input.first + ' ' +  ((this.input.middle != '') ? this.input.middle + ' ' : '') + this.input.last }}</td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter" colspan="1"><!--Address:-->{{ $t("intake.revMemberAddress") }}</td>
                            <td class="review-field review-field-three-quarter" colspan="3"> {{ this.input.street + ((this.input.suite != '') ? ', ' + this.input.suite : '') }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter" colspan="1"> </td>
                            <td class="review-field review-field-three-quarter" colspan="3"> {{ this.input.city + ', ' + this.input.stateText + ' ' + this.input.zipcode }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter" colspan="1"><!--Email:-->{{ $t("intake.revMemberEmail") }}</td>
                            <td class="review-field review-field-three-quarter" colspan="3"> {{ this.input.email }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter" colspan="1"><!--Phone:-->{{ $t("intake.revMemberPhone") }}</td>
                            <td class="review-field review-field-three-quarter" colspan="3"> {{ this.input.phone + ( (this.input.phoneExt != '') ? ( ', ' + this.input.phoneExt ) : ( '' ) ) }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Cell:-->{{ $t("intake.revMemberCell") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.cell }}</td>
                            <td class="review-field-title review-field-quarter"><!--Fax:-->{{ $t("intake.revMemberFax") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.fax }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Date of Birth:-->{{ $t("intake.revMemberDOB") }}</td>
                            <td class="review-field review-field-quarter"> {{ reviewDateOfBirth }} </td>
                            <td class="review-field-title review-field-quarter"><!--Gender:-->{{ $t("intake.revMemberGender") }}</td>
                            <td class="review-field review-field-quarter"> {{ (this.input.gender == true) ? 'Male' : 'Female'  }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Langauge:-->{{ $t("intake.revMemberLanguage") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.languageText }} </td>
                            <td class="review-field-title review-field-quarter"><!--Handedness:-->{{ $t("intake.revMemberHandedness") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.handednessText }}
                          </tr>
                          <tr>
                            <td class="review-section" colspan="4">
                              <div style="height:20px"/>
                                <!--*** HEALTH INSURANCE ***-->
                                {{ $t("intake.revInsuranceTitle") }}
                            </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Insurer:-->{{ $t("intake.revInsurer") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.insurancePayer }}</td>
                            <td class="review-field-title review-field-quarter"><!--Plan Name:-->{{ $t("intake.revPlanName") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.planName }}</td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Plan Type:-->{{ $t("intake.revPlanType") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.planType }}</td>
                            <td class="review-field-title review-field-quarter"><!--Effective Date:-->{{ $t("intake.revEffectiveDate") }}</td>
                            <td class="review-field review-field-quarter"> {{ reviewCoverageEffectiveDate }}</td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Group Number:-->{{ $t("intake.revGroup") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.planGroupNumber }}</td>
                            <td class="review-field-title review-field-quarter"><!--Member Number:-->{{ $t("intake.revMemberNumber") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.insuranceIdentifier }}</td>
                          </tr>
                          <tr>
                            
                            <td class="review-section" colspan="4">
                              <div style="height:20px"/>
                              <!--*** GOVERNMENT ***-->
                              {{ $t("intake.revGovernmentTitle") }}
                            </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--Drivers License Number:-->{{ $t("intake.revLicenseNumber") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.driversLicense }} </td>
                            <td class="review-field-title review-field-quarter"><!--Issuing State:-->{{ $t("intake.revLicenseState") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.driversLicenseStateText }} </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-quarter"><!--License Class:-->{{ $t("intake.revLicenseClass") }}</td>
                            <td class="review-field review-field-quarter"> {{ this.input.driversLicenseClassText }} </td>
                            <td class="review-field-title review-field-quarter" colspan=""><!--CLP/CDL Application/Holder:-->{{ $t("intake.revLicenseCLPCDL") }}</td>
                            <td class="review-field review-field-quarter" colspan="1"> {{ (this.input.cplCdlApplicationHolder == true) ? "Yes" : "No" }}</td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-half" colspan="2"><!--Has your USDOT/FMCSA medical certificate ever been denied or issued for less than 2 years?:-->{{ $t("intake.revLicenseUSDOT") }}</td>
                            <td class="review-field review-field-half" colspan="2"> {{ (this.input.usdotFmcsaCertDenied == true) ? "Yes" : "No" }} </td>
                          </tr>
                          <tr>
                            <td class="review-section" colspan="4">
                              <div style="height:20px"/>
                              <!--*** GENERAL ***-->
                              {{ $t("intake.revGenTitle") }}
                              </td>
                          </tr>
                          <tr>
                            <td class="review-field-title review-field-half" colspan="2"><!--Who is providing this medical history?:-->{{ $t("intake.genSource") }}</td>
                            <td class="review-field review-field-three-half" colspan="2"> {{ this.input.sourceOfHistoryText }}</td>
                          </tr>
                          <tr v-if="this.input.hadSurgery">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever had surgery?:-->{{ $t("intake.genHadSurgery") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.hadSurgeryExplanation }} </td>
                          </tr>
                          <tr v-if="this.input.takingMedications">
                            <td class="review-field-title review-field-half" colspan="2"><!--Are you currently taking any medications?:-->{{ $t("intake.genTakingMeds") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.takingMedicationsExplanation }} </td>
                          </tr>
                          <tr v-if="this.input.wereYouHospitalized">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever been Hospitalized?:-->{{ $t("intake.genBeenHospitalized") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.wereYouHospitalizedNote }} </td>
                          </tr>
                          <tr v-if="this.input.nightInHospital">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever spent a night in the hospital?:-->{{ $t("intake.genNightInHospital") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.nightInHostpitalNote }} </td>
                          </tr>
                          <tr>
                            <td class="review-section" colspan="4">
                              <div style="height:20px"/>
                              <!--*** CONDITIONS ***-->
                              {{ $t("intake.revCondTitle") }}
                            </td>
                          </tr>
                          <!-- HEAD / BRAIN INJURIES -->
                          <tr v-if="this.input.headBrain">
                            <td class="review-field-title review-field-half" colspan="2"><!--Head/brain injuries or illnesses (e.g., concussion)-->{{ $t("intake.condHeadBrain") }}</td>
                            <td class="review-field review-field--half" colspan="2">{{ this.input.headBrainNote }} </td>
                          </tr>
                          <!-- SEIZURES OR EPILEPSY -->
                          <tr v-if="this.input.seizuresEpilepsy">
                            <td class="review-field-title review-field-half" colspan="2"><!--Seizures, epilepsy:-->{{ $t("intake.condSeizuresEpilepsy") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.seizuresEpilepsyNote }} </td>
                          </tr>
                          <!-- EYE PROBLEMS -->
                          <tr v-if="this.input.eyeProblems">
                            <td class="review-field-title review-field-half" colspan="2"><!--Eye problems (except glasses or contacts):-->{{ $t("intake.condEyeProblems") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.eyeProblemsNote }} </td>
                          </tr>
                          <!-- EAR / HEARING PROBLEMS -->
                          <tr v-if="this.input.earHearingProblems">
                            <td class="review-field-title review-field-half" colspan="2"><!--Ear and/or hearing problems:-->{{ $t("intake.condEarHearingProblems") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.earHearingProblemsNote }} </td>
                          </tr>
                          <!-- DIABETES -->
                          <tr v-if="this.input.diabetes">
                            <td class="review-field-title review-field-half" colspan="2"><!--Diabetes or blood sugar problems:-->{{ $t("intake.condDiabetes") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.diabetesNote }} </td>
                          </tr>
                          <!-- INSULIN USED -->
                          <tr v-if="this.input.insulinUsed">
                            <td class="review-field-title review-field-half" colspan="2"><!--Insulin Used:-->{{ $t("intake.condInsulinUsed") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.insulinUsedNote }} </td>
                          </tr>
                          <!-- ANXIETY / DEPRESSION -->
                          <tr v-if="this.input.anxietyDepression">
                            <td class="review-field-title review-field-half" colspan="2"><!--Anxiety, depression, nervousness, other mental health problems:-->{{ $t("intake.condAnxietyDepression") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.anxietyDepressionNote }} </td>
                          </tr>
                          <!-- FAINTING -->
                          <tr v-if="this.input.fainting">
                            <td class="review-field-title review-field-half" colspan="2"><!--Fainting or passing out:-->{{ $t("intake.condFainting") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.faintingNote }} </td>
                          </tr>
                          <!-- HEART DISEASE -->
                          <tr v-if="this.input.heartDisease">
                            <td class="review-field-title review-field-half" colspan="2"><!--Heart disease, heart attack, bypass, or other heart problems:-->{{ $t("intake.condHeartDisease") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.heartDiseaseNote }} </td>
                          </tr>
                          <!-- PACEMAKER / STENTS -->
                          <tr v-if="this.input.paceMakerStents">
                            <td class="review-field-title review-field-half" colspan="2"><!--Pacemaker,stents, implantable devices, or other heart procedures:-->{{ $t("intake.condPaceMakerStents") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.paceMakerStentsNote }} </td>
                          </tr>
                          <!-- HIGH BLOOD PRESSURE -->
                          <tr v-if="this.input.highBloodPressure">
                            <td class="review-field-title review-field-half" colspan="2"><!--High Blood Pressure:-->{{ $t("intake.condHighBloodPressure") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.highBloodPressureNote }} </td>
                          </tr>
                          <!-- HIGH CHOLESTEROL -->
                          <tr v-if="this.input.highCholesterol">
                            <td class="review-field-title review-field-half" colspan="2"><!--High cholesterol:-->{{ $t("intake.condHighCholesterol") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.highCholesterolNote }} </td>
                          </tr>
                          <!-- UNEXPECTED WEIGHT LOSS -->
                          <tr v-if="this.input.unexplainedWeightLoss">
                            <td class="review-field-title review-field-half" colspan="2"><!--Unexplained Weight Loss:-->{{ $t("intake.condUnexplainedWeightLoss") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.unexplainedWeightLossNote }} </td>
                          </tr>
                          <!-- STROKE -->
                          <tr v-if="this.input.stroke">
                            <td class="review-field-title review-field-half" colspan="2"><!--Stroke, mini-stroke (TIA), paralysis, or weakness:-->{{ $t("intake.condStroke") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.strokeNote }} </td>
                          </tr>
                          <!-- BROKEN BONE -->
                          <tr v-if="this.input.brokenBone">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever had a broken bone?:-->{{ $t("intake.condBrokenBone") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.brokenBoneNote }} </td>
                          </tr>
                          <!-- CHRONIC COUGH -->
                          <tr v-if="this.input.chronicCough">
                            <td class="review-field-title review-field-half" colspan="2"><!--Chronic (long-term) cough, shortness of breath, or other breathing problems:-->{{ $t("intake.condChronicCough") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.chronicCoughNote }} </td>
                          </tr>
                          <!-- LUNG DISEASE -->
                          <tr v-if="this.input.lungDisease">
                            <td class="review-field-title review-field-half" colspan="2"><!--Lung disease (e.g., asthma):-->{{ $t("intake.condLungDisease") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.lungDiseaseNote }} </td>
                          </tr>
                          <!-- KIDNEY PROBLEMS -->
                          <tr v-if="this.input.kidneyProblems">
                            <td class="review-field-title review-field-half" colspan="2"><!--Kidney problems, kidney stones, or pain/problems with urination:-->{{ $t("intake.condKidneyProblems") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.kidneyProblemsNote }} </td>
                          </tr>
                          <!-- STOMACH / LIVER -->
                          <tr v-if="this.input.stomachLiver">
                            <td class="review-field-title review-field-half" colspan="2"><!--Stomach, liver, or digestive problems:-->{{ $t("intake.condStomachLiver") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.stomachLiverNote }} </td>
                          </tr>
                          <!-- BONE / MUSCLE -->
                          <tr v-if="this.input.boneMuscle">
                            <td class="review-field-title review-field-half" colspan="2"><!--Bone, muscle, joint, or nerve problems:-->{{ $t("intake.condBoneMuscle") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.boneMuscleNote }} </td>
                          </tr>
                          <!-- CANCER -->
                          <tr v-if="this.input.cancer">
                            <td class="review-field-title review-field-half" colspan="2"><!--Cancer:-->{{ $t("intake.condCancer") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.cancerNote }} </td>
                          </tr>
                          <!-- DIZZINESS / HEADACHES -->
                          <tr v-if="this.input.dizzinessHeadaches">
                            <td class="review-field-title review-field-half" colspan="2"><!--Dizziness, headaches, numbness, tingling, or memory loss:-->{{ $t("intake.condDizzinessHeadaches") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.dizzinessHeadachesNote }} </td>
                          </tr>
                          <!-- BLOOD CLOTS OR BLEEDING -->
                          <tr v-if="this.input.bloodClotsBleeding">
                            <td class="review-field-title review-field-half" colspan="2"><!--Blood clots or bleeding problems:-->{{ $t("intake.condBloodClotsBleeding") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.bloodClotsBleedingNote }} </td>
                          </tr>
                          <!-- NECK / BACK -->
                          <tr v-if="this.input.neckBack">
                            <td class="review-field-title review-field-half" colspan="2"><!--Neck or back problems:-->{{ $t("intake.condNeckBack") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.neckBackNote }} </td>
                          </tr>
                          <!-- SLEEPING DISORDERS -->
                          <tr v-if="this.input.sleepingDisorders">
                            <td class="review-field-title review-field-half" colspan="2"><!--Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring:-->{{ $t("intake.condSleepingDisorders") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.sleepingDisordersNote }} </td>
                          </tr>
                          <!-- CHRONIC INFECTIONS -->
                          <tr v-if="this.input.chronicInfection">
                            <td class="review-field-title review-field-half" colspan="2"><!--Chronic (long-term) infection or other chronic diseases:-->{{ $t("intake.condChronicInfection") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.chronicInfectionNote }} </td>
                          </tr>
                          <!-- MISSING / LIMITED USE OF LIMBS -->
                          <tr v-if="this.input.missingLimitedUserOfArms">
                            <td class="review-field-title review-field-half" colspan="2"><!--Missing or limited use of arm, hand, finger, leg, foot, toe:-->{{ $t("intake.condMissingLimitedUserOfArms") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.missingLimitedUserOfArmsNote }} </td>
                          </tr>
                          <td class="review-section" colspan="4">
                              <div style="height:20px"/>
                              <!--*** LIFESTYLE ***-->
                              {{ $t("intake.revLifeTitle") }}
                            </td>
                          <!-- DRINK ALCOHOL -->
                          <tr v-if="this.input.drinkAlcohol">
                            <td class="review-field-title review-field-half" colspan="2"><!--Do you currently drink alcohol?:-->{{ $t("intake.lifeDrinkAlcohol") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.drinkAlcoholNote }} </td>
                          </tr>
                          <!-- EVER TREATED FOR SUBSTANCE -->
                          <tr v-if="this.input.treatedForSubstance">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you Ever been Treated For Substance Issue?:-->{{ $t("intake.lifeTreatedForSubstance") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.treatedForSubstanceNote }} </td>
                          </tr>
                          <!-- OTHER HEALTH CONDITION -->
                          <tr v-if="this.input.otherHealthCondition">
                            <td class="review-field-title review-field-half" colspan="2"><!--Other Health Condition:-->{{ $t("intake.lifeOtherHealthCondition") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.otherHealthConditionNote }} </td>
                          </tr>
                          <!-- DO YOU USE TABACCO -->
                          <tr v-if="this.input.useTobacco">
                            <td class="review-field-title review-field-half" colspan="2"><!--Do you Use Tabacco:-->{{ $t("intake.lifeUseTobacco") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.useTobaccoNote }} </td>
                          </tr>
                          <!-- FAILED DRUG TEST -->
                          <tr v-if="this.input.everFailedDrugTest">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever failed a drug test or been dependent on an illegal substance?:-->{{ $t("intake.lifeEverFailedDrugTest") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.everFailedDrugTestNote }} </td>
                          </tr>
                          <!-- ILLEGAL SUBSTANCES -->
                          <tr v-if="this.input.illegalSubstance">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you used an illegal substance within the past two years?:-->{{ $t("intake.lifeIllegalSubstance") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.illegalSubstanceNote }} </td>
                          </tr>
                          <!-- SLEEP TEST -->
                          <tr v-if="this.input.sleepTest">
                            <td class="review-field-title review-field-half" colspan="2"><!--Have you ever had a sleep test (e.g., sleep apnea)?:-->{{ $t("intake.lifeSleepTest") }}</td>
                            <td class="review-field review-field-half" colspan="2">{{ this.input.sleepTestNote }} </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- FINISHED -->
      <tr>
        <td class="screen-table-td">
          <div id="finished" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table class="section-table-width" border="0" align="center">
                    <tr>
                      <td class="text-finished-field" colspan="2">
                        <div style="height:10px;"/>
                        <!--Thank you for updating your health history.-->
                        {{ $t("intake.finInstruction1") }}
                        <br><br>
                        <!--This medical history information will be used for any upcomming physical you have scheduled.-->
                        {{ $t("intake.finInstruction2") }}
                        <br><br>
                        <!--If you have questions regarding this information or how it is used, please call us at 888-423-3926.-->
                        {{ $t("intake.finInstruction3") }}
                        <br><br>
                        <!--Thank you for making eHealth Engagement your choice for excellent health care.-->
                        {{ $t("intake.finInstruction4") }}
                        <div style="height:10px;"/>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>    
      </tr>
      <!-- LOADING -->
      <tr>
        <td class="screen-table-td">
          <div id="loading" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <div style="height:100px;"/>
                        <img src="../../../assets/images/working.gif" style="background-color:transparent;height:40px" >
                        <div style="height:100px;"/>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>   
      </tr>
      <!-- COMMANDS -->
      <tr>
        <td class="screen-table-td">
          <div style="height:10px;"></div>
          <table class="section-table" border="0" align="center">
              <tr>
                <td class="commands radius-top-left-field-top radius-top-right-field-top radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:20px;"></div>
                  <table border="0" align="center">
                    <tr>
                      <td style="text-align:center;">
                        <input type="button" ref="cmdNack" :value="$t('intake.back')" v-on:click="back()" :disabled="backDisabled">
                        <input type="button" ref="cmdNext" :value="$t('intake.save')" v-on:click="next()" :disabled="nextDisabled">
                      </td>
                    </tr>
                  </table>
                  <div style="height:20px;"></div>
                </td>
              </tr>
          </table>
          <div style="height:50px;"></div>
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
//import VueLoadingButton from "vue-loading-button";
import messageBox from '.././common/message-box'
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

import moment from 'moment'

export default {
  name: 'medical-history',
  components: {
    //VueLoadingButton
  },
  data() {
      return {
        input: {
          stage:0,
          createDate: "",
          lastUpdate: "",
          first : "",
          middle: "",
          last : "",
          street: "",
          suite: "",
          city: "",
          stateId: 0,
          stateText:"",
          zipcode: "",
          email : "",
          phone: "",
          phoneExt: "",
          cell : "",
          fax: "",
          dateOfBirth: "1/1/1900",
          gender: true,
          languageId:0,
          languageText:"",
          handednessId:0,
          handednessText:"",
          insurancePayer: "",
          planName: "",
          planType: "",
          coverageEffectiveDate: "1/1/1900",
          planGroupNumber:"",
          insuranceIdentifier:"",
          driversLicense:"",
          driversLicenseStateId:0,
          driversLicenseStateText:"",
          driversLicenseClassId:0,
          driversLicenseClassText:"",
          cplCdlApplicationHolder:false,
          usdotFmcsaCertDenied:false,
          sourceOfHistoryId:0,
          sourceOfHistoryText:"",
          hadSurgery:0,
          hadSurgeryExplanation:"",
          takingMedications:false,
          takingMedicationsExplanation:"",
          headBrain:false,
          headBrainNote:"",
          seizuresEpilepsy:false,
          seizuresEpilepsyNote:"",
          eyeProblems:false,
          eyeProblemsNote:"",
          earHearingProblems:false,
          earHearingProblemsNote:"",
          heartDisease:false,
          heartDiseaseNote:"",
          paceMakerStents:false,
          paceMakerStentsNote:"",
          highBloodPressure :false,
          highBloodPressureNote:"",
          highCholesterol:false,
          highCholesterolNote:"",
          chronicCough:false,
          chronicCoughNote:"",
          lungDisease:false,
          lungDiseaseNote:"",
          kidneyProblems:false,
          kidneyProblemsNote:"",
          stomachLiver:false,
          stomachLiverNote:"",
          diabetes:false,
          diabetesNote:"",
          insulinUsed:false,
          insulinUsedNote:"",
          anxietyDepression:false,
          anxietyDepressionNote:"",
          fainting:false,
          faintingNote:"",
          dizzinessHeadaches:false,
          dizzinessHeadachesNote:"",
          unexplainedWeightLoss:false,
          unexplainedWeightLossNote:"",
          stroke:false,
          strokeNote:"",
          missingLimitedUserOfArms:false,
          missingLimitedUserOfArmsNote:"",
          neckBack:false,
          neckBackNote:"",
          boneMuscle:false,
          boneMuscleNote:"",
          cancer:false,
          cancerNote:"",
          chronicInfection:false,
          chronicInfectionNote:"",
          sleepingDisorders:false,
          sleepingDisordersNote:"",
          sleepTest:false,
          sleepTestNote:"",
          nightInHospital:false,
          nightInHostpitalNote:"",
          brokenBone:false,
          brokenBoneNote:"",
          useTobacco:false,
          useTobaccoNote:"",
          drinkAlcohol:false,
          drinkAlcoholNote:"",
          illegalSubstance:false,
          illegalSubstanceNote:"",
          everFailedDrugTest:false,
          everFailedDrugTestNote:"",
          otherHealthCondition:false,
          otherHealthConditionNote:"",
          bloodClotsBleeding:false,
          bloodClotsBleedingNote:"",
          anyPrecludingCondition:false,
          anyPrecludingConditionNote:"",
          treatedForSubstance :false,
          treatedForSubstanceNote:"",
          wereYouHospitalized:false,
          wereYouHospitalizedNote:"",
          hipaaAcknowledgement:false,
          hipaaAcknowledgementDigitalSignature :"",
          hipaaAcknowledgementTimeStamp:"1/1/1900",
          medicalRecordsReleaseAcknowledgement:false,
          medicalRecordsReleaseAcknowledgementDigitalSignature:"",
          medicalRecordsReleaseAcknowledgementTimeStamp:"1/1/1900",
          teleHealthInformedConsent:false,
          teleHealthInformedConsentDigitalSignature:"",
          teleHealthInformedConsentTimeStamp:"1/1/1900"
      },
      nextDisabled:false,
      backDisabled:false,
      //isLoading:false
    }
  },
  computed: {
    reviewDateOfBirth:{
      get() {
        return moment(this.input.dateOfBirth).format('MM-DD-YYYY');
      }
    },
    reviewCoverageEffectiveDate:{
      get() {
        return moment(this.input.coverageEffectiveDate).format('MM-DD-YYYY');
      }
    },
    dateOfBirth: {
      get() {
        return moment(this.input.dateOfBirth).format('YYYY-MM-DD');
        //return t;
      },
      set(val)
      {
        this.input.dateOfBirth = val;
      }      
    },
    coverageEffectiveDate: {
      get() {
        return moment(this.input.coverageEffectiveDate).format('YYYY-MM-DD');
        //return t;
      },
      set(val)
      {
        /* if(val == "")
        {
           this.$generalMessage(messageBox, this.input.coverageEffectiveDate); //this.$t('intake.onDiabetes'))
           var x = document.getElementById("coverageEffectiveDate")
           
           x.value = this.input.coverageEffectiveDate;
           this.$generalMessage(messageBox, document.getElementById("coverageEffectiveDate").value);
           return;
        } */
        this.input.coverageEffectiveDate = val;
      }      
    },
    stateList : {
     get() {
       return API.readStateList();
     } 
    },
    historySource : {
      get() {
        return API.readHistorySource(this.$i18n.locale);
      }
    }   
  },
  methods: {
    focusInput() {
        // SET DEFAULT CONTROL
        this.$refs.first.focus();
    },
    onSelectChange(event) {
      /* DAMN THIS SUCKS */
      const options = event.target.options;
      const selectedOption = options[options.selectedIndex];
      switch(event.target.id)
      {
        case "stateId":
          {
            this.input.stateText = selectedOption.textContent;
            break;
          }
        case "driversLicenseStateId":
          {
            this.input.driversLicenseStateText = selectedOption.textContent;
            break;
          }
        case "languageId":
          {
            this.input.languageText = selectedOption.textContent;
            break;
          }
        case "handednessId":
          {
            this.input.handednessText = selectedOption.textContent;
            break;
          }
        case "driversLicenseClassId":
          {
            this.input.driversLicenseClassText = selectedOption.textContent;
            break;
          }
        case "sourceOfHistoryId":
          {
            this.input.sourceOfHistoryText = selectedOption.textContent;
            break;
          }
      }
      
    },
    onDiabetes(e){
      if(e.target.checked)
      {
        this.$generalMessage(messageBox, this.$t('intake.onDiabetes'));
      }
    },
    onInsulinUsed(e){
      if(e.target.checked)
      {
        this.input.diabetes = true;
      }
    },
    load() {
      
      SUPPORT.showServiceMenus();
      
      document.getElementById('menuMedicalHistory').classList.add('is-hidden');

      var loading = document.getElementById("loading");
      var memberInformation = document.getElementById("memberInformation");
      var healthInsurance = document.getElementById("healthInsurance");
      var govInformation = document.getElementById("govInformation");
      var medicalHistory1 = document.getElementById("medicalHistory1");
      var medicalHistory1Notes = document.getElementById("medicalHistory1Notes");
      var medicalHistory2 = document.getElementById("medicalHistory2");
      var medicalHistory2Notes = document.getElementById("medicalHistory2Notes");
      var medicalHistory3 = document.getElementById("medicalHistory3");
      var medicalHistory3Notes = document.getElementById("medicalHistory3Notes");
      var summary = document.getElementById("summary"); 
      var finished = document.getElementById("finished");
      
      loading.style.display = "block";
      memberInformation.style.display = "none";
      healthInsurance.style.display = "none";
      govInformation.style.display = "none";
      medicalHistory1.style.display = "none";
      medicalHistory1Notes.style.display = "none";
      medicalHistory2.style.display = "none";
      medicalHistory2Notes.style.display = "none";
      medicalHistory3.style.display = "none"; 
      medicalHistory3Notes.style.display = "none";    
      summary.style.display = "none";
      finished.style.display = "none";
      
      var statusMemberInformation = document.getElementById("statusMemberInformation");
      statusMemberInformation.classList.add("status-field-current");

      this.backDisabled = true; 

      API.readIntake(window.sessionKey, this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.input.isLoading = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
            
            this.input.stage = 0; //response.data.stage;
            this.input.createDate = response.data.createDate;
            this.input.lastUpdate = response.data.lastUpdate;
            this.input.first = response.data.first;
            this.input.middle = response.data.middle;
            this.input.last = response.data.last;
            this.input.street = response.data.street;
            this.input.suite = response.data.suite;
            this.input.city = response.data.city;
            this.input.stateId = response.data.stateId;
            this.input.stateText = response.data.stateText;
            this.input.zipcode = response.data.zipcode;
            this.input.email = response.data.email;
            this.input.phone = response.data.phone;
            this.input.phoneExt = response.data.phoneExt;
            this.input.cell = response.data.cell;
            this.input.fax = response.data.fax;
            this.input.dateOfBirth = new Date(response.data.dateOfBirth);
            this.input.gender = response.data.gender;
            this.input.languageId = response.data.languageId;
            this.input.languageText = response.data.languageText;
            this.input.handednessId = response.data.handednessId;
            this.input.handednessText = response.data.handednessText;
            this.input.insurancePayer = response.data.insurancePayer;
            this.input.planName = response.data.planName;
            this.input.planType = response.data.planType;
            this.input.coverageEffectiveDate = response.data.coverageEffectiveDate;
            //alert(this.input.coverageEffectiveDate);
            if(new Date(this.input.coverageEffectiveDate).getTime() == new Date("1900-01-01T00:00:00").getTime())
            {
              
              this.input.coverageEffectiveDate = new Date();//moment(new Date()).format('MM-DD-YYYY');
              //alert(this.input.coverageEffectiveDate)
            }
            this.input.planGroupNumber = response.data.planGroupNumber;
            this.input.insuranceIdentifier = response.data.insuranceIdentifier;
            this.input.driversLicense = response.data.driversLicense;
            this.input.driversLicenseStateId = response.data.driversLicenseStateId;
            this.input.driversLicenseStateText = response.data.driversLicenseStateText;
            this.input.driversLicenseClassId = response.data.driversLicenseClassId;
            this.input.driversLicenseClassText = response.data.driversLicenseClassText;
            this.input.cplCdlApplicationHolder = response.data.cplCdlApplicationHolder;
            this.input.usdotFmcsaCertDenied = response.data.usdotFmcsaCertDenied;
            this.input.sourceOfHistoryId = response.data.sourceOfHistoryId;
            this.input.sourceOfHistoryText = response.data.sourceOfHistoryText;
            this.input.hadSurgery = response.data.hadSurgery;
            this.input.hadSurgeryExplanation = response.data.hadSurgeryExplanation;
            this.input.takingMedications = response.data.takingMedications;
            this.input.takingMedicationsExplanation = response.data.takingMedicationsExplanation;
            this.input.headBrain = response.data.headBrain;
            this.input.headBrainNote = response.data.headBrainNote;
            this.input.seizuresEpilepsy = response.data.seizuresEpilepsy;
            this.input.seizuresEpilepsyNote = response.data.seizuresEpilepsyNote;
            this.input.eyeProblems = response.data.eyeProblems;
            this.input.eyeProblemsNote = response.data.eyeProblemsNote;
            this.input.earHearingProblems = response.data.earHearingProblems;
            this.input.earHearingProblemsNote = response.data.earHearingProblemsNote;
            this.input.heartDisease = response.data.heartDisease;
            this.input.heartDiseaseNote = response.data.heartDiseaseNote;
            this.input.paceMakerStents = response.data.paceMakerStents;
            this.input.paceMakerStentsNote = response.data.paceMakerStentsNote;
            this.input.highBloodPressure = response.data.highBloodPressure;
            this.input.highBloodPressureNote = response.data.highBloodPressureNote;
            this.input.highCholesterol = response.data.highCholesterol;
            this.input.highCholesterolNote = response.data.highCholesterolNote;
            this.input.chronicCough = response.data.chronicCough;
            this.input.chronicCoughNote = response.data.chronicCoughNote;
            this.input.lungDisease = response.data.lungDisease;
            this.input.lungDiseaseNote = response.data.lungDiseaseNote;
            this.input.kidneyProblems = response.data.kidneyProblems;
            this.input.kidneyProblemsNote = response.data.kidneyProblemsNote;
            this.input.stomachLiver = response.data.stomachLiver;
            this.input.stomachLiverNote = response.data.stomachLiverNote;
            this.input.diabetes = response.data.diabetes;
            this.input.diabetesNote = response.data.diabetesNote;
            this.input.insulinUsed = response.data.insulinUsed;
            this.input.insulinUsedNote = response.data.insulinUsedNote;
            this.input.anxietyDepression = response.data.anxietyDepression;
            this.input.anxietyDepressionNote = response.data.anxietyDepressionNote;
            this.input.fainting = response.data.fainting;
            this.input.faintingNote = response.data.faintingNote;
            this.input.dizzinessHeadaches = response.data.dizzinessHeadaches;
            this.input.dizzinessHeadachesNote = response.data.dizzinessHeadachesNote;
            this.input.unexplainedWeightLoss = response.data.unexplainedWeightLoss;
            this.input.unexplainedWeightLossNote = response.data.unexplainedWeightLossNote;
            this.input.stroke = response.data.stroke;
            this.input.strokeNote = response.data.strokeNote;
            this.input.missingLimitedUserOfArms = response.data.missingLimitedUserOfArms;
            this.input.missingLimitedUserOfArmsNote = response.data.missingLimitedUserOfArmsNote;
            this.input.neckBack = response.data.neckBack;
            this.input.neckBackNote = response.data.neckBackNote;
            this.input.boneMuscle = response.data.boneMuscle;
            this.input.boneMuscleNote = response.data.boneMuscleNote;
            this.input.cancer = response.data.cancer;
            this.input.cancerNote = response.data.cancerNote;
            this.input.chronicInfection = response.data.chronicInfection;
            this.input.chronicInfectionNote = response.data.chronicInfectionNote;
            this.input.sleepingDisorders = response.data.sleepingDisorders;
            this.input.sleepingDisordersNote = response.data.sleepingDisordersNote;
            this.input.sleepTest = response.data.sleepTest;
            this.input.sleepTestNote = response.data.sleepTestNote;
            this.input.nightInHospital = response.data.nightInHospital;
            this.input.nightInHostpitalNote = response.data.nightInHostpitalNote;
            this.input.brokenBone = response.data.brokenBone;
            this.input.brokenBoneNote = response.data.brokenBoneNote;
            this.input.useTobacco = response.data.useTobacco;
            this.input.useTobaccoNote = response.data.useTobaccoNote;
            this.input.drinkAlcohol = response.data.drinkAlcohol;
            this.input.drinkAlcoholNote = response.data.drinkAlcoholNote;
            this.input.illegalSubstance = response.data.illegalSubstance;
            this.input.illegalSubstanceNote = response.data.illegalSubstanceNote;
            this.input.everFailedDrugTest = response.data.everFailedDrugTest;
            this.input.everFailedDrugTestNote = response.data.everFailedDrugTestNote;
            this.input.otherHealthCondition = response.data.otherHealthCondition;
            this.input.otherHealthConditionNote = response.data.otherHealthConditionNote;
            this.input.bloodClotsBleeding = response.data.bloodClotsBleeding;
            this.input.bloodClotsBleedingNote = response.data.bloodClotsBleedingNote;
            this.input.anyPrecludingCondition = response.data.anyPrecludingCondition;
            this.input.anyPrecludingConditionNote = response.data.anyPrecludingConditionNote;
            this.input.treatedForSubstance = response.data.treatedForSubstance;
            this.input.treatedForSubstanceNote = response.data.treatedForSubstanceNote;
            this.input.wereYouHospitalized = response.data.wereYouHospitalized;
            this.input.wereYouHospitalizedNote = response.data.wereYouHospitalizedNote;
            this.input.hipaaAcknowledgement = response.data.hipaaAcknowledgement;
            this.input.hipaaAcknowledgementDigitalSignature = response.data.hipaaAcknowledgementDigitalSignature;
            this.input.hipaaAcknowledgementTimeStamp = response.data.hipaaAcknowledgementTimeStamp;
            this.input.medicalRecordsReleaseAcknowledgement = response.data.medicalRecordsReleaseAcknowledgement;
            this.input.medicalRecordsReleaseAcknowledgementDigitalSignature = response.data.medicalRecordsReleaseAcknowledgementDigitalSignature;
            this.input.medicalRecordsReleaseAcknowledgementTimeStamp = response.data.medicalRecordsReleaseAcknowledgementTimeStamp;
            this.input.teleHealthInformedConsent = response.data.teleHealthInformedConsent;
            this.input.teleHealthInformedConsentDigitalSignature = response.data.teleHealthInformedConsentDigitalSignature;
            this.input.teleHealthInformedConsentTimeStamp = response.data.teleHealthInformedConsentTimeStamp;

            var statusMemberInformation = document.getElementById("statusMemberInformation");
            statusMemberInformation.classList.add("status-field-current"); 
            loading.style.display = "none";
            memberInformation.style.display = "block";

        }
      }).catch( e =>
      {
        loading.style.display = "none";
        this.$generalMessage( messageBox, e );            
      })

      
      
    },
    next(){

      //this.isLoading = true;
      // VALIDATE INPUT
      if(!this.validateInput(this.input.stage))
      { 
        //this.isLoading = false;
        return;
      }

      var loading = document.getElementById("loading");
      var memberInformation = document.getElementById("memberInformation");
      var healthInsurance = document.getElementById("healthInsurance");
      var govInformation = document.getElementById("govInformation");
      var medicalHistory1 = document.getElementById("medicalHistory1");
      var medicalHistory1Notes = document.getElementById("medicalHistory1Notes");
      var medicalHistory2 = document.getElementById("medicalHistory2");
      var medicalHistory2Notes = document.getElementById("medicalHistory2Notes");
      var medicalHistory3 = document.getElementById("medicalHistory3");
      var medicalHistory3Notes = document.getElementById("medicalHistory3Notes");
      var summary =  document.getElementById("summary");
      var finished = document.getElementById("finished");
      var statusMemberInformation = document.getElementById("statusMemberInformation");
      var statusHealthInsurance = document.getElementById("statusHealthInsurance");
      var statusGovernmentInformation = document.getElementById("statusGovernmentInformation");
      var statusMedicalHistory1 = document.getElementById("statusMedicalHistory1");
      var statusMedicalHistory1Notes = document.getElementById("statusMedicalHistory1Notes");
      var statusMedicalHistory2 = document.getElementById("statusMedicalHistory2");
      var statusMedicalHistory2Notes = document.getElementById("statusMedicalHistory2Notes");
      var statusMedicalHistory3 = document.getElementById("statusMedicalHistory3");
      var statusMedicalHistory3Notes = document.getElementById("statusMedicalHistory3Notes");
      var statusSummary = document.getElementById("statusSummary");
      var statusFinished = document.getElementById("statusFinished");

      statusMemberInformation.classList.remove("status-field-current");
      statusHealthInsurance.classList.remove("status-field-current");
      statusGovernmentInformation.classList.remove("status-field-current");
      statusMedicalHistory1.classList.remove("status-field-current");
      statusMedicalHistory1Notes.classList.remove("status-field-current");
      statusMedicalHistory2.classList.remove("status-field-current");
      statusMedicalHistory2Notes.classList.remove("status-field-current");
      statusMedicalHistory3.classList.remove("status-field-current");
      statusMedicalHistory3Notes.classList.remove("status-field-current");
      statusSummary.classList.remove("status-field-current");
      statusFinished.classList.remove("status-field-current");

      memberInformation.style.display = "none";
      healthInsurance.style.display = "none";
      govInformation.style.display = "none";
      medicalHistory1.style.display = "none";
      medicalHistory1Notes.style.display = "none";
      medicalHistory2.style.display = "none";
      medicalHistory2Notes.style.display = "none";
      medicalHistory3.style.display = "none"; 
      medicalHistory3Notes.style.display = "none"; 
      summary.style.display = "none";
      finished.style.display = "none";
      loading.style.display = "block";

      this.backDisabled = false;
      this.nextDisabled = false;
      this.$refs.cmdNext.value = this.$t('intake.save');

      this.input.stage++;

      if( (!this.hasGeneral()) && (this.input.stage == 4) )
      {
        // SKIP CONDITION DETAILS
        this.input.stage = 5;
      }

      if( (!this.hasConditions()) && (this.input.stage == 6) )
      {
        // SKIP CONDITION DETAILS
        this.input.stage = 7;
      }

      if( (!this.hasLifeStyle() && this.input.stage == 8) )
      {
        // SKIPE LIFE STYLE DETAILS
        this.input.stage = 9;
      }

      switch(this.input.stage){
        case 0:
          {
            loading.style.display = "none";
            memberInformation.style.display = "block";
            statusMemberInformation.classList.add("status-field-current");
            break;
          }
        case 1: // INSURANCE
          {
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                memberInformation.style.display = "block";
                statusMemberInformation.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                healthInsurance.style.display = "block";
                statusHealthInsurance.classList.add("status-field-current");
              }
            });
            break;
          }
        case 2: // GOVERNMENT
          {
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                healthInsurance.style.display = "block";
                statusHealthInsurance.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                govInformation.style.display = "block";
                statusGovernmentInformation.classList.add("status-field-current");
              }
            });
            break;
          }
        case 3: // GENERAL
          {
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                govInformation.style.display = "block";
                statusGovernmentInformation.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory1.style.display = "block";
                statusMedicalHistory1.classList.add("status-field-current");
              }
            });
            break;
          }
         case 4: // GENERAL DETAILS
          {
            if(this.input.sourceOfHistoryId == 0)
            {
              this.$generalMessage(messageBox, "Missing field: Who is providing this medical history?");
              this.input.stage--;
              loading.style.display = "none";
              medicalHistory1.style.display = "block";
              statusMedicalHistory1.classList.add("status-field-current");
              break;
            }
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory1.style.display = "block";
                statusMedicalHistory1.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory1Notes.style.display = "block";
                statusMedicalHistory1Notes.classList.add("status-field-current");
              }
            });
            break;
          }
        case 5: // CONDITIONS
          {
            // VALIDATE GENERAL
            if(!this.validateGeneralInput())
            {
              this.input.stage--;
              loading.style.display = "none";
              medicalHistory1Notes.style.display = "block";
              statusMedicalHistory1Notes.classList.add("status-field-current");
              break;
            }

            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory1Notes.style.display = "block";
                statusMedicalHistory1Notes.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory2.style.display = "block";
                statusMedicalHistory2.classList.add("status-field-current");
              }
            });
            break;
          }
        case 6: // CONDITION DETAILS
          {
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory2.style.display = "block";
                statusMedicalHistory2.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory2Notes.style.display = "block";
                statusMedicalHistory2Notes.classList.add("status-field-current");
              }
            });
            break;
          }
        case 7: // LIFESTYLE
          {
            // VALIDATE CONDITION DETAILS
            if(!this.validateConditionDetailInput())
            {
              this.input.stage--;
              loading.style.display = "none";
              medicalHistory2Notes.style.display = "block";
              break;
            }

            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory2Notes.style.display = "block";
                statusMedicalHistory2Notes.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory3.style.display = "block"; 
                statusMedicalHistory3.classList.add("status-field-current");
              }
            });
            break;
          }
        case 8: // LIFESTYLE DETAILS
          {
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory3.style.display = "block"; 
                statusMedicalHistory3.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                medicalHistory3Notes.style.display = "block"; 
                statusMedicalHistory3Notes.classList.add("status-field-current");
              }
            });
            break;
          }
        case 9: // REVIEW
          {
            if(!this.validateLifeStyle())
            {
              this.input.stage--;
              loading.style.display = "none";
              medicalHistory3Notes.style.display = "block";
              break;
            }
            this.updateIntake()
            .then(response => {
              if(response.data.hasError == true)
              {
                this.$generalMessage(messageBox, response.data.errorMessage);
                SUPPORT.securityCheck(response.data.errorId);
                this.input.stage--;
                loading.style.display = "none";
                medicalHistory3Notes.style.display = "block"; 
                statusMedicalHistory3Notes.classList.add("status-field-current");
              }
              else
              {
                loading.style.display = "none";
                summary.style.display = "block";
                statusSummary.classList.add("status-field-current");
              }
            }); 
            break;
          }
        case 10: // FINISHED
          {
            loading.style.display = "none";
            finished.style.display = "block";
            statusFinished.classList.add("status-field-current");
            this.$refs.cmdNext.value = this.$t('intake.close');
            break;
          }
        case 11: // END
          {
            //this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
            {
              this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 2) // FIT FOR DUTY
            {
              this.$router.push( { path: "/members/daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
            {
              this.$router.push( { path: "/members/dashboard"} );
            }
          }
      }
      // SHOW TOP OF VIEW
      window.scrollTo(0, 0);
      //this.isLoading = false;
    },
    print() {
      
      var prtContent = document.getElementById("printSection");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    back(){
      var loading = document.getElementById("loading");
      var memberInformation = document.getElementById("memberInformation");
      var healthInsurance = document.getElementById("healthInsurance");
      var govInformation = document.getElementById("govInformation");
      var medicalHistory1 = document.getElementById("medicalHistory1");
      var medicalHistory1Notes = document.getElementById("medicalHistory1Notes");
      var medicalHistory2 = document.getElementById("medicalHistory2");
      var medicalHistory2Notes = document.getElementById("medicalHistory2Notes");
      var medicalHistory3 = document.getElementById("medicalHistory3");
      var medicalHistory3Notes = document.getElementById("medicalHistory3Notes");
      var summary = document.getElementById("summary");
      var finished = document.getElementById("finished");

      var statusMemberInformation = document.getElementById("statusMemberInformation");
      var statusHealthInsurance = document.getElementById("statusHealthInsurance");
      var statusGovernmentInformation = document.getElementById("statusGovernmentInformation");
      var statusMedicalHistory1 = document.getElementById("statusMedicalHistory1");
      var statusMedicalHistory1Notes = document.getElementById("statusMedicalHistory1Notes");
      var statusMedicalHistory2 = document.getElementById("statusMedicalHistory2");
      var statusMedicalHistory2Notes = document.getElementById("statusMedicalHistory2Notes");
      var statusMedicalHistory3 = document.getElementById("statusMedicalHistory3");
      var statusMedicalHistory3Notes = document.getElementById("statusMedicalHistory3Notes");
      var statusSummary =  document.getElementById("statusSummary");
      var statusFinished = document.getElementById("statusFinished");

      statusMemberInformation.classList.remove("status-field-current");
      statusHealthInsurance.classList.remove("status-field-current");
      statusGovernmentInformation.classList.remove("status-field-current");
      statusMedicalHistory1.classList.remove("status-field-current");
      statusMedicalHistory1Notes.classList.remove("status-field-current");
      statusMedicalHistory2.classList.remove("status-field-current");
      statusMedicalHistory2Notes.classList.remove("status-field-current");
      statusMedicalHistory3.classList.remove("status-field-current");
      statusMedicalHistory3Notes.classList.remove("status-field-current");
      statusSummary.classList.remove("status-field-current");
      statusFinished.classList.remove("status-field-current");

      memberInformation.style.display = "none";
      healthInsurance.style.display = "none";
      govInformation.style.display = "none";
      medicalHistory1.style.display = "none";
      medicalHistory1Notes.style.display = "none";
      medicalHistory2.style.display = "none";
      medicalHistory2Notes.style.display = "none";
      medicalHistory3.style.display = "none";       
      medicalHistory3Notes.style.display = "none";
      summary.style.display = "none";
      finished.style.display = "none";
      loading.style.display = "block";

      this.$refs.cmdNext.value = this.$t('intake.save');

      this.backDisabled = false;
      this.nextDisabled = false;
      
      this.input.stage--;

      if( (!this.hasGeneral()) && (this.input.stage == 4) )
      {
        // SKIP CONDITION DETAILS
        this.input.stage = 3;
      }

      if( (!this.hasConditions()) && (this.input.stage == 6) )
      {
        // SKIP CONDITION DETAILS
        this.input.stage = 5;
      }
      if( (!this.hasLifeStyle()) && (this.input.stage == 8) )
      {
        // SKIP CONDITION DETAILS
        this.input.stage = 7;
      }

      switch(this.input.stage){
        case 0:
          {
            loading.style.display = "none";
            memberInformation.style.display = "block";
            statusMemberInformation.classList.add("status-field-current");
            this.backDisabled = true;
            break;
          }
        case 1:
          {
            loading.style.display = "none";
            healthInsurance.style.display = "block";
            statusHealthInsurance.classList.add("status-field-current");
            break;
          }
        case 2:
          {
            loading.style.display = "none";
            govInformation.style.display = "block";
            statusGovernmentInformation.classList.add("status-field-current");
            break;
          }
        case 3:
          {
            loading.style.display = "none";
            medicalHistory1.style.display = "block";
            statusMedicalHistory1.classList.add("status-field-current");
            break;
          }
        case 4:
          {
            loading.style.display = "none";
            medicalHistory1Notes.style.display = "block";
            statusMedicalHistory1Notes.classList.add("status-field-current");
            break;
          }
        case 5:
          {
            loading.style.display = "none";
            medicalHistory2.style.display = "block";
            statusMedicalHistory2.classList.add("status-field-current");
            break;
          }
        case 6:
          {
            loading.style.display = "none";
            medicalHistory2Notes.style.display = "block";
            statusMedicalHistory2Notes.classList.add("status-field-current");
            break;
          }
        case 7:
          {
            loading.style.display = "none";
            medicalHistory3.style.display = "block"; 
            statusMedicalHistory3.classList.add("status-field-current");
            break;
          }   
        case 8:
          {
            loading.style.display = "none";
            medicalHistory3Notes.style.display = "block"; 
            statusMedicalHistory3Notes.classList.add("status-field-current");
            break;
          }   
        case 9:
          {
            /* summary.style.display = "block"; 
            statusSummary.classList.add("status-field-current"); */
            loading.style.display = "none";
            memberInformation.style.display = "block";
            statusMemberInformation.classList.add("status-field-current");
            this.input.stage = 0;
            this.backDisabled = true;
            break;
          } 
        case 10:
          {
            loading.style.display = "none";
            finished.style.display = "block"; 
            statusFinished.classList.add("status-field-current");
            break;
          }  
      }
      // SHOW TOP OF VIEW
      window.scrollTo(0, 0);
    },
    validateInput(stage)
    {
     
      switch(stage)
      {
        case 0: // MEMBER INFORMATION
        {
          if(this.input.street == "")
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingStreet'));
            return false;
          }
          if(this.input.city == "")
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingCity'));
            return false;
          }
          if(this.input.stateId == 0)
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingState'));
            return false;
          }
          if((this.input.zipcode == "") || (this.input.zipcode.length < 5))
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingZipcode'));
            return false;
          }
          if((this.input.phone == "") || (this.input.phone.length < 13))
          {
            this.$generalMessage(messageBox, this.$t('intake.valInvalidPhone'));
            return false;
          }
          if((this.input.cell == "") || (this.input.cell.length < 13))
          {
            this.$generalMessage(messageBox, this.$t('intake.valInvalidCell'));
            return false;
          }
          if(this.input.email == "")
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingEmail'));
            return false;
          }
          if (!this.checkEmail(this.input.email))
          {
            this.$generalMessage(messageBox, this.$t('intake.valInvalidEmail'));
            return false;
          }
          if(this.input.dateOfBirth == "") 
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingDOB'));
            return false;
          }
          if(new Date(this.input.dateOfBirth).getTime() == new Date("1900-01-01T00:00:00").getTime())
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingDOB'));
            return false;
          }
          var now = moment();
          var minBD = now.add('years', -18);
          if(new Date(this.input.dateOfBirth) > minBD)
          {
            this.$generalMessage(messageBox, this.$t('intake.valInvalidDOB'));
            return false;
          }
         /*  if((this.input.gebder == false) && (this.input.female == false))
          {
            this.$generalMessage(messageBox, "Mising gender.");
            return false;
          } */
          if(this.input.languageId == 0)
          {
            this.$generalMessage(messageBox, this.$t('intake.valMissingLanguage'));
            return false;
          }
          if(this.input.handednessId == 0)
          { 
            this.$generalMessage(messageBox, this.$t('intake.valMissingHandedness'));
            return false;
          }

          return true;
        }
        case 1: // HEALTH INSURANCE
        {
          /* if(this.input.insurancePayer == "")
          {
            this.$generalMessage(messageBox, "Mising Insurer.");
            return false;
          } 
          if(this.input.coverageEffectiveDate == "") 
          {
            this.$generalMessage(messageBox, "Mising Effective Date.");
            return false;
          }
          if(new Date(this.input.coverageEffectiveDate).getTime() == new Date("1900-01-01T00:00:00").getTime())
          {
            this.$generalMessage(messageBox, "Mising Effective Date.");
            return false;
          }
          if(new Date(this.input.coverageEffectiveDate) > new Date())
          {
            this.$generalMessage(messageBox, "Effective Date cannot be in the future.");
            return false;
          }
          if(this.input.planGroupNumber == "")
          {
            this.$generalMessage(messageBox, "Mising group number.");
            return false;
          }
          if(this.input.insuranceIdentifier == "")
          {
            this.$generalMessage(messageBox, "Mising member number.");
            return false;
          } */
          return true;
        }
        case 2: // GOVERNMENT
        {
          if(this.input.driversLicense != "") 
          {
            if(this.input.driversLicenseStateId == 0)
            {
              this.$generalMessage(messageBox, this.$t('intake.valMissingIssuingState'));
              return false;
            }

            if(this.input.driversLicenseClassId == 0)
            {
              this.$generalMessage(messageBox, this.$t('intake.valMissingClass'));
              return false;
            }
          }
        }
      }
      return true;
    },
    checkEmail(email) {
      const reg = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
      if (!reg.test(email)) return false;
      return true;
    },
    clearNote(name)
    { 
      var obj = this["input"];
      obj[name] = false;
      obj[name + "Note"] = "";
    },
    makeCheckMsg(msg, item, note, element)
    {
      if( (item) && (note == "") ) 
      { 
        this.$generalMessage(messageBox, msg +  document.getElementById(element).textContent);
        return false;
      }
      else
      {
        return true;
      }
    },
    hasGeneral()
    {
      if((this.input.hadSurgery) ||
      (this.input.takingMedications) ||
      (this.input.wereYouHospitalized) ||
      (this.input.nightInHospital))
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    hasLifeStyle()
    {
      if((this.input.drinkAlcohol) ||
      (this.input.treatedForSubstance) ||
      (this.input.otherHealthCondition) ||
      (this.input.useTobacco) ||
      (this.input.everFailedDrugTest) ||
      (this.input.illegalSubstance) ||
      (this.input.sleepTest))
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    hasConditions()
    {
     
      if((this.input.headBrain) ||
        (this.input.seizuresEpilepsy) ||
        (this.input.eyeProblems) ||
        (this.input.earHearingProblems) ||
        (this.input.diabetes) ||
        (this.input.insulinUsed) ||
        (this.input.anxietyDepression) ||
        (this.input.fainting) ||
        (this.input.heartDisease) ||
        (this.input.paceMakerStents) ||
        (this.input.highBloodPressure) ||
        (this.input.highCholesterol) ||
        (this.input.unexplainedWeightLoss) ||
        (this.input.stroke) ||
        (this.input.brokenBone) ||
        (this.input.chronicCough) ||
        (this.input.lungDisease) ||
        (this.input.kidneyProblems) ||
        (this.input.stomachLiver) ||
        (this.input.boneMuscle) ||
        (this.input.cancer) ||
        (this.input.dizzinessHeadaches) ||
        (this.input.bloodClotsBleeding) ||
        (this.input.neckBack) ||
        (this.input.sleepingDisorders) ||
        (this.input.chronicInfection) ||
        (this.input.missingLimitedUserOfArms))
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    validateGeneralInput()
    {

      var msg = this.$t('intake.answerRequired');
      if(!this.makeCheckMsg(msg, this.input.hadSurgery, this.input.hadSurgeryExplanation, "lblHadSurgery")) return false;
      if(!this.makeCheckMsg(msg, this.input.takingMedications, this.input.takingMedicationsExplanation, "lblTakingMedications")) return false;
      if(!this.makeCheckMsg(msg, this.input.wereYouHospitalized, this.input.wereYouHospitalizedNote, "lblWereYouHospitalized")) return false;
      if(!this.makeCheckMsg(msg, this.input.nightInHospital, this.input.nightInHostpitalNote, "lblNightInHospital")) return false;
      
      return true;
    },
    validateConditionDetailInput()
    {
      var msg = this.$t('intake.answerRequired');
      
      if(!this.makeCheckMsg(msg, this.input.headBrain, this.input.headBrainNote, "lblHeadBrain")) return false;
      if(!this.makeCheckMsg(msg, this.input.seizuresEpilepsy, this.input.seizuresEpilepsyNote, "lblSeizuresEpilepsy")) return false;
      if(!this.makeCheckMsg(msg, this.input.eyeProblems, this.input.eyeProblemsNote, "lblEyeProblems")) return false;
      if(!this.makeCheckMsg(msg, this.input.earHearingProblems, this.input.earHearingProblemsNote, "lblEarHearingProblems")) return false;
      if(!this.makeCheckMsg(msg, this.input.diabetes, this.input.diabetesNote, "lblDiabetes")) return false;
      if(!this.makeCheckMsg(msg, this.input.insulinUsed, this.input.insulinUsedNote, "lblInsulinUsed")) return false;
      if(!this.makeCheckMsg(msg, this.input.anxietyDepression, this.input.anxietyDepressionNote, "lblAnxietyDepression")) return false;
      if(!this.makeCheckMsg(msg, this.input.fainting, this.input.faintingNote, "lblFainting")) return false;
      if(!this.makeCheckMsg(msg, this.input.heartDisease, this.input.heartDiseaseNote, "lblHeartDisease")) return false;
      if(!this.makeCheckMsg(msg, this.input.paceMakerStents, this.input.paceMakerStentsNote, "lblPaceMakerStents")) return false;
      if(!this.makeCheckMsg(msg, this.input.highBloodPressure, this.input.highBloodPressureNote, "lblHighBloodPressure")) return false;
      if(!this.makeCheckMsg(msg, this.input.highCholesterol, this.input.highCholesterolNote, "lblHighCholesterol")) return false;
      if(!this.makeCheckMsg(msg, this.input.unexplainedWeightLoss, this.input.unexplainedWeightLossNote, "lblUnexplainedWeightLoss")) return false;
      if(!this.makeCheckMsg(msg, this.input.stroke, this.input.strokeNote, "lblStroke")) return false;
      if(!this.makeCheckMsg(msg, this.input.brokenBone, this.input.brokenBoneNote, "lblBrokenBone")) return false;
      if(!this.makeCheckMsg(msg, this.input.chronicCough, this.input.chronicCoughNote, "lblChronicCough")) return false;
      if(!this.makeCheckMsg(msg, this.input.lungDisease, this.input.lungDiseaseNote, "lblLungDisease")) return false;
      if(!this.makeCheckMsg(msg, this.input.kidneyProblems, this.input.kidneyProblemsNote, "lblKidneyProblems")) return false;
      if(!this.makeCheckMsg(msg, this.input.stomachLiver, this.input.stomachLiverNote, "lblStomachLiver")) return false;
      if(!this.makeCheckMsg(msg, this.input.boneMuscle, this.input.boneMuscleNote, "lblBoneMuscle")) return false;
      if(!this.makeCheckMsg(msg, this.input.cancer, this.input.cancerNote, "lblCancer")) return false;
      if(!this.makeCheckMsg(msg, this.input.dizzinessHeadaches, this.input.dizzinessHeadachesNote, "lblDizzinessHeadaches")) return false;
      if(!this.makeCheckMsg(msg, this.input.bloodClotsBleeding, this.input.bloodClotsBleedingNote, "lblBloodClotsBleeding")) return false;
      if(!this.makeCheckMsg(msg, this.input.neckBack, this.input.neckBackNote, "lblNeckBack")) return false;
      if(!this.makeCheckMsg(msg, this.input.sleepingDisorders, this.input.sleepingDisordersNote, "lblSleepingDisorders")) return false;
      if(!this.makeCheckMsg(msg, this.input.chronicInfection, this.input.chronicInfectionNote, "lblChronicInfection")) return false;
      if(!this.makeCheckMsg(msg, this.input.missingLimitedUserOfArms, this.input.missingLimitedUserOfArmsNote, "lblMissingLimitedUserOfArms")) return false;
        
      return true;
    },
    validateLifeStyle()
    {
      var msg = this.$t('intake.answerRequired');

      if(!this.makeCheckMsg(msg, this.input.drinkAlcohol, this.input.drinkAlcoholNote, "lblDrinkAlcohol")) return false;
      if(!this.makeCheckMsg(msg, this.input.treatedForSubstance, this.input.treatedForSubstanceNote, "lblTreatedForSubstance")) return false;
      if(!this.makeCheckMsg(msg, this.input.otherHealthCondition, this.input.otherHealthConditionNote, "lblOtherHealthCondition")) return false;
      if(!this.makeCheckMsg(msg, this.input.useTobacco, this.input.useTobaccoNote, "lblUseTobacco")) return false;
      if(!this.makeCheckMsg(msg, this.input.everFailedDrugTest, this.input.everFailedDrugTestNote, "lblEverFailedDrugTest")) return false;
      if(!this.makeCheckMsg(msg, this.input.illegalSubstance, this.input.illegalSubstanceNote, "lblllegalSubstance")) return false;
      if(!this.makeCheckMsg(msg, this.input.sleepTest, this.input.sleepTestNote, "lblSleepTest")) return false;
      
      return true;
    },
    updateIntake()
    {
      return new Promise((resolve, reject) =>
      {
        // SAVE MEDICAL HISTORY
        API.updateIntake(window.sessionKey,
          this.$i18n.locale,
          this.input.stage,
          this.input.first,
          this.input.middle,
          this.input.last,
          this.input.street,
          this.input.suite,
          this.input.city,
          parseInt(this.input.stateId),
          this.input.zipcode,
          this.input.email,
          this.input.phone,
          this.input.phoneExt,
          this.input.cell,
          this.input.fax,
          this.input.dateOfBirth,
          this.input.gender,
          parseInt(this.input.languageId),
          parseInt(this.input.handednessId),
          this.input.insurancePayer,
          this.input.planName,
          this.input.planType,
          this.checkDate(this.input.coverageEffectiveDate),
          this.input.planGroupNumber,
          this.input.insuranceIdentifier,
          this.input.driversLicense,
          parseInt(this.input.driversLicenseStateId),
          parseInt(this.input.driversLicenseClassId),
          this.input.cplCdlApplicationHolder,
          this.input.usdotFmcsaCertDenied,
          parseInt(this.input.sourceOfHistoryId),
          this.input.hadSurgery,
          this.input.hadSurgeryExplanation,
          this.input.takingMedications,
          this.input.takingMedicationsExplanation,
          this.input.headBrain,
          this.input.headBrainNote,
          this.input.seizuresEpilepsy,
          this.input.seizuresEpilepsyNote,
          this.input.eyeProblems,
          this.input.eyeProblemsNote,
          this.input.earHearingProblems,
          this.input.earHearingProblemsNote,
          this.input.heartDisease,
          this.input.heartDiseaseNote,
          this.input.paceMakerStents,
          this.input.paceMakerStentsNote,
          this.input.highBloodPressure,
          this.input.highBloodPressureNote,
          this.input.highCholesterol,
          this.input.highCholesterolNote,
          this.input.chronicCough,
          this.input.chronicCoughNote,
          this.input.lungDisease,
          this.input.lungDiseaseNote,
          this.input.kidneyProblems,
          this.input.kidneyProblemsNote,
          this.input.stomachLiver,
          this.input.stomachLiverNote,
          this.input.diabetes,
          this.input.diabetesNote,
          this.input.insulinUsed,
          this.input.insulinUsedNote,
          this.input.anxietyDepression,
          this.input.anxietyDepressionNote,
          this.input.fainting,
          this.input.faintingNote,
          this.input.dizzinessHeadaches,
          this.input.dizzinessHeadachesNote,
          this.input.unexplainedWeightLoss,
          this.input.unexplainedWeightLossNote,
          this.input.stroke,
          this.input.strokeNote,
          this.input.missingLimitedUserOfArms,
          this.input.missingLimitedUserOfArmsNote,
          this.input.neckBack,
          this.input.neckBackNote,
          this.input.boneMuscle,
          this.input.boneMuscleNote,
          this.input.cancer,
          this.input.cancerNote,
          this.input.chronicInfection,
          this.input.chronicInfectionNote,
          this.input.sleepingDisorders,
          this.input.sleepingDisordersNote,
          this.input.sleepTest,
          this.input.sleepTestNote,
          this.input.nightInHospital,
          this.input.nightInHostpitalNote,
          this.input.brokenBone,
          this.input.brokenBoneNote,
          this.input.useTobacco,
          this.input.useTobaccoNote,
          this.input.drinkAlcohol,
          this.input.drinkAlcoholNote,
          this.input.illegalSubstance,
          this.input.illegalSubstanceNote,
          this.input.everFailedDrugTest,
          this.input.everFailedDrugTestNote,
          this.input.otherHealthCondition,
          this.input.otherHealthConditionNote,
          this.input.bloodClotsBleeding,
          this.input.bloodClotsBleedingNote,
          this.input.anyPrecludingCondition,
          this.input.anyPrecludingConditionNote,
          this.input.treatedForSubstance,
          this.input.treatedForSubstanceNote,
          this.input.wereYouHospitalized,
          this.input.wereYouHospitalizedNote,
          this.input.hipaaAcknowledgement,
          this.input.hipaaAcknowledgementDigitalSignature,
          this.input.hipaaAcknowledgementTimeStamp,
          this.input.medicalRecordsReleaseAcknowledgement,
          this.input.medicalRecordsReleaseAcknowledgementDigitalSignature,
          this.input.medicalRecordsReleaseAcknowledgementTimeStamp,
          this.input.teleHealthInformedConsent,
          this.input.teleHealthInformedConsentDigitalSignature,
          this.input.teleHealthInformedConsentTimeStamp)
        .then(response => {
          resolve( response )
        })
        .catch(error => {
          reject( error );
        });
      });
    },
    checkDate(val)
    {
      if(isNaN(Date.parse(val)))
      {
        return "1900-01-01T00:00:00";
      }
      else
      {
        return this.input.coverageEffectiveDate;
      }
    }
  },
  mounted () {
  
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);

    this.load();

    // FOCUS ON THE USER NAME
    this.focusInput();

 }
}
</script>


<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.disabled {
  background-color:darkgray;
}

.enabled {
  background-color: white;
}
// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  table { // KEY, FIXES TABLE TO MOBILE WIDTH
    table-layout:fixed;
  }
  
  // CORNER SUPPORT 
 .radius-single-left-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    overflow:hidden;
  } 
  .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    overflow:hidden;
  }
  .radius-single-right-field-left-top
  {
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  // END CORNER SUPPORT

  //////////////////////////////////////////////
  // ******* SCREEN ******* 
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }  
  #screen-row1
  {
    height:100%; 
  }
  .screen-table-td
  {
    margin:auto;
  }
  // ******* END SCREEN ******* 

  // ******* MAIN TITLE ******* 
  #title-left
  {
    width:100%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  // ******* END MAIN TITLE ******* 

  // ******* TAB SECTION SUPPORT *******   
  .section-table
  {
    width:96%;
  }
  // ******* END TAB SECTION SUPPORT ******* 

  // ******* TABS ******* 
  .status-field
  {
    visibility: hidden;
    height: 0px;
    /*height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    color:white;
    word-wrap:break-word;
    font-family:Lato;
    font-size:18px;
    font-weight:400; 
    padding-left:3px;
    padding-right:3px;*/
  }
  .status-field-current
  {
    visibility: visible;
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#4682B4;
    color:white;
    font-family:Lato;
    font-size:20px;
    font-weight:400; 
    word-wrap:break-word;
  }
  // ******* END TABS ******* 

  // ******* MEMBER PAGE *******
  .mem-section-table-width
  {
    width:80%;
  }
  .mem-instruction-field
  {
    //height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 20px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .mem-text-field
  {
    height:25px;
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: top;
    text-align: left;
    background-color:#343F68;
    color:white;
    //padding-left: 5px;
    //padding-right: 5px;
    white-space: nowrap;
  }
  .member-input-width
  {
    width:100%;
  }
  // ******* END MEMBER PAGE *******

  // ******* INSURANCE PAGE *******
  .ins-section-table-width
  {
    width:80%;
  }
  .ins-instruction-field
  {
    //height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 20px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .ins-input-width
  {
    width:100%;
  }
  // ******* END INSURANCE PAGE *******

  // ******* GOVERNMENT PAGE *******
  .gov-section-table-width
  {
    width:80%;
  }
  .gov-instruction-field
  {
    //height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .gov-input-width
  {
    width:100%;
  }
  // ******* END GOVERNMENT PAGE *******

  // ******* GENERAL PAGE *******
  .gen-section-table-width
  {
    width:80%;
  }
  // ******* END GENERAL PAGE *******

  // ******* GENERAL DETAILS PAGE *******
  // ******* END GENERAL DETAILS PAGE *******

  // ******* CONDITIONS PAGE *******
  .cond-instruction-field
  {
    //height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 20px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .cond-section-table-width
  {
    width:80%;
  }
  .condition
  {
    width:100%;
    min-width:300px;
    float:left;
  }
  .condition-div
  {
    height:auto;
    resize:none;
    overflow:auto;
    padding-bottom:10px;
  }
  // ******* END CONDITIONS PAGE *******

  // ******* CONDITION DETAILS PAGE *******
  // ******* END CONDITION DETAILS PAGE *******

  // ******* SUMMARY/REVIEW PAGE *******
  .sum-instruction-field
  {
    //height:25px;
    vertical-align: top;
    text-align: center;
    background-color:#343F68;
    font-size: 20px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .review-section
  {
    text-align: center;
    font-family:Lato;
    font-family:Courier;
    font-size: 20px;
    font-weight:800; 
    border-bottom-style: solid;
    border-bottom-color:#4682B4 ;
    border-bottom-width: 1px;
  }
  .review-field-title
  {
    font-family:Lato;
    font-family:Courier;
    font-size: 18px;
    font-weight:600; 
  }
  
  .review-field
  {
    font-family:Lato;
    font-family:Courier;
    font-size: 18px;
    font-weight:400; 
  }
  .review-field-full
  {
    width:100%;
  }
  .review-field-quarter
  {
    width:100%;
  }
  .review-field-half
  {
    width:100%;
  }
  .review-field-three-quarter
  {
    width:100%;
  }
  // ******* END SUMMARY/REVIEW PAGE *******

  // ******* FINISHED PAGE *******
  .text-finished-field
  {
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    color:white;
    word-wrap:break-word;
  }
  // ******* END FINISHED PAGE *******

  // ******* SHARED TABLE *******
  .section-table-width
  {
    width:80%;
  }
  .table-td-pad
  {
    padding-bottom: 10px;
  }
  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }
  .section-border-left
  {
    border-left-style: solid;
    border-left-color:#4682B4 ;
    border-left-width: 1px;
  }
  // ******* END SHARED TABLE *******

  // ******* SHARED TABLE TEXT *******
  .input-field-empty
  {
    visibility: hidden;
  }
  .text-field
  {
    //height:25px;
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: top;
    text-align: left;
    background-color:#343F68;
    color:white;
    //padding-left: 5px;
    //padding-right: 5px;
  }
  .text-field-half
  {
    width:auto;//50%;
  }
  // ******* END SHARED TABLE TEXT *******

  // ******* SHARED TABLE INPUT *******
  .input-field
  {
    //height:25px;
    vertical-align: top;
    text-align: left;
    background-color:#343F68;
    color:white;
    //padding-left: 5px;
    //padding-right: 5px;
  }
  .input-field-third
  {
    width:auto;//33%;
  }
  .input-field-half
  {
    width:auto;//50%;
  }
  // ******* SHARED TABLE INPUT *******

  // ******* SHARED TABLE INSTRUCTIONS *******
  .instruction-field
  {
    //height:25px;
    vertical-align: top;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    //padding-left: 10%;
    //padding-right: 10%;
  }
  // ******* END SHARED TABLE INSTRUCTIONS *******

  // ******* OTHER SHARED *******
  .border-dots
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }
  .commands
  {
    padding-top:10px;
    text-align: center !important;
    vertical-align:middle !important;
    background-color:darkgray;//#343F68;
    color:white;
  }
  .printtd
  {
    visibility: hidden;
    //text-align:right;
  }
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // ******* SCREEN ******* 
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }  
  #screen-row1
  {
    height:50px; 
  }
  .screen-table-td
  {
    margin:auto;
  }
  // ******* END SCREEN ******* 

  // ******* MAIN TITLE ******* 
  #title-left
  {
    width:20%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  // ******* END MAIN TITLE ******* 

  // ******* TAB SECTION SUPPORT *******   
  .section-table
  {
    width:98%;
  }
  // ******* END TAB SECTION SUPPORT ******* 

  // ******* TABS ******* 
  .status-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    color:white;
    word-wrap:break-word;
    font-family:Lato;
    font-size:18px;
    font-weight:400; 
    padding-left:3px;
    padding-right:3px;
  }
  .status-field-current
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#4682B4;
    color:white;
    font-family:Lato;
    font-size:20px;
    font-weight:400; 
    word-wrap:break-word;
  }
  // ******* END TABS ******* 

  // ******* MEMBER PAGE *******
  .mem-section-table-width
  {
    width:70%;
  }
  .mem-instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .mem-text-field
  {
    height:25px;
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: top;
    text-align: right;
    background-color:#343F68;
    color:white;
    padding-left: 5px;
    padding-right: 5px;
    white-space: nowrap;
  }
  .member-input-width
  {
    width:100%;
  }
  // ******* END MEMBER PAGE *******

  // ******* INSURANCE PAGE *******
  .ins-section-table-width
  {
    width:50%;
  }
  .ins-instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .ins-input-width
  {
    width:240px;
  }
  // ******* END INSURANCE PAGE *******

  // ******* GOVERNMENT PAGE *******
  .gov-section-table-width
  {
    width:60%;
  }
  .gov-instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .gov-input-width
  {
    width:140px;
  }
  // ******* END GOVERNMENT PAGE *******

  // ******* GENERAL PAGE *******
  .gen-section-table-width
  {
    width:60%;
  }
  // ******* END GENERAL PAGE *******

  // ******* GENERAL DETAILS PAGE *******
  // ******* END GENERAL DETAILS PAGE *******

  // ******* CONDITIONS PAGE *******
  .cond-instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .cond-section-table-width
  {
    width:90%;
  }
  .condition
  {
    width:90%;
    min-width:300px;
    float:left;
  }
  .condition-div
  {
    height:auto;
    resize:none;
    overflow:auto;
    padding-bottom:10px;
  }
  // ******* END CONDITIONS PAGE *******

  // ******* CONDITION DETAILS PAGE *******
  // ******* END CONDITION DETAILS PAGE *******

  // ******* SUMMARY/REVIEW PAGE *******
  .sum-instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
  }
  .review-section
  {
    text-align: center;
    font-family:Lato;
    font-family:Courier;
    font-size: 24px;
    font-weight:800; 
    border-bottom-style: solid;
    border-bottom-color:#4682B4 ;
    border-bottom-width: 1px;
  }
  .review-field-title
  {
    font-family:Lato;
    font-family:Courier;
    font-size: 18px;
    font-weight:600; 
  }
  
  .review-field
  {
    font-family:Lato;
    font-family:Courier;
    font-size: 18px;
    font-weight:400; 
  }
  .review-field-full
  {
    width:100%;
  }
  .review-field-quarter
  {
    width:25% !important;
  }
  .review-field-half
  {
    width:50%;
  }
  .review-field-three-quarter
  {
    width:75%;
  }
  // ******* END SUMMARY/REVIEW PAGE *******

  // ******* FINISHED PAGE *******
  .text-finished-field
  {
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    color:white;
    word-wrap:break-word;
  }
  // ******* END FINISHED PAGE *******

  // ******* SHARED TABLE *******
  .section-table-width
  {
    width:70%;
  }
  .table-td-pad
  {
    padding-bottom: 10px;
  }
  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }
  .section-border-left
  {
    border-left-style: solid;
    border-left-color:#4682B4 ;
    border-left-width: 1px;
  }
  .input-field-empty
  {
    width:auto;
  }
  // ******* END SHARED TABLE *******

  // ******* SHARED TABLE TEXT *******
  .text-field
  {
    height:25px;
    font-family:Lato;
    font-size:16px;
    font-weight:400; 
    vertical-align: top;
    text-align: right;
    background-color:#343F68;
    color:white;
    padding-left: 5px;
    padding-right: 5px;
  }
  .text-field-half
  {
    width:50%;
  }
  // ******* END SHARED TABLE TEXT *******

  // ******* SHARED TABLE INPUT *******
  .input-field
  {
    height:25px;
    vertical-align: top;
    text-align: left;
    background-color:#343F68;
    color:white;
    padding-left: 5px;
    padding-right: 5px;
  }
  .input-field-third
  {
    width:33%;
  }
  .input-field-half
  {
    width:50%;
  }
  // ******* SHARED TABLE INPUT *******

  // ******* SHARED TABLE INSTRUCTIONS *******
  .instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    padding-left: 10%;
    padding-right: 10%;
  }
  // ******* END SHARED TABLE INSTRUCTIONS *******

  // ******* OTHER SHARED *******
  .border-dots
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }
  .commands
  {
    padding-top:10px;
    vertical-align:middle !important;
    background-color:darkgray;//#343F68;
    color:white;
  }
  .printtd
  {
    text-align:right;
    
  }
  // ******* CORNER SUPPORT *******
  .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  // ******* END CORNER SUPPORT *******
}
</style>